// Core theme JS for MOGI
// - Mobile menu toggle
// - Cart count updates
// - Mega menu positioning

(function() {
  'use strict';

  var isDesignMode = typeof Shopify !== 'undefined' && !!Shopify.designMode;

  // Mobile menu toggle (fixed left panel + overlay on small screens)
  var mobileMenuToggle = document.querySelector('.mobile-menu-toggle');
  var navMenu = document.querySelector('.nav-menu');
  var mobileNavPanel = document.querySelector('[data-mobile-nav-panel]');
  var mainHeader = document.querySelector('.main-header');
  var mobileNavOverlay = document.querySelector('[data-mobile-nav-overlay]');
  var mobileNavCloseButtons = document.querySelectorAll('[data-mobile-nav-close]');

  function measureSiteHeaderHeight() {
    var root = document.querySelector('[data-sticky-header-root]');
    var measureTarget = root || mainHeader;
    if (!measureTarget) return 0;
    return Math.round(measureTarget.getBoundingClientRect().height);
  }

  function initHeaderStickySection() {
    if (!mainHeader) mainHeader = document.querySelector('.main-header');
    if (!mainHeader) return;

    var enabled = mainHeader.getAttribute('data-sticky-header') === 'true';
    document.body.classList.toggle('has-sticky-header', enabled);

    if (!enabled) {
      document.documentElement.style.removeProperty('--site-header-height');
      return;
    }

    var height = measureSiteHeaderHeight();
    if (height > 0) {
      document.documentElement.style.setProperty('--site-header-height', height + 'px');
    }
    updateHeaderBottom();
  }

  initHeaderStickySection();
  window.addEventListener('load', initHeaderStickySection);
  window.addEventListener('resize', initHeaderStickySection);

  if (isDesignMode && typeof document.addEventListener === 'function') {
    document.addEventListener('shopify:section:load', function(evt) {
      if (evt.target && evt.target.querySelector && evt.target.querySelector('.main-header')) {
        mainHeader = evt.target.querySelector('.main-header') || document.querySelector('.main-header');
        initHeaderStickySection();
      }
    });
  }

  function updateHeaderBottom() {
    if (!mainHeader) return;
    var y = Math.round(mainHeader.getBoundingClientRect().bottom);
    document.documentElement.style.setProperty('--header-bottom', y + 'px');
    document.documentElement.style.setProperty('--mobile-nav-top', y + 'px');
  }

  function setMobileMenuIcon(isOpen) {
    var svg = mobileMenuToggle ? mobileMenuToggle.querySelector('svg') : null;
    if (!svg) return;
    if (isOpen) {
      svg.innerHTML = '<path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>';
    } else {
      svg.innerHTML = '<path d="M3 12H21M3 6H21M3 18H21" stroke="currentColor" stroke-linecap="round"/>';
    }
  }

  function setMobileNavOpen(isOpen) {
    if (!navMenu || !mobileMenuToggle) return;
    navMenu.classList.toggle('active', isOpen);
    if (mobileNavPanel) {
      mobileNavPanel.classList.toggle('is-open', isOpen);
      mobileNavPanel.classList.toggle('active', isOpen);
    }
    mobileMenuToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    mobileMenuToggle.setAttribute('aria-label', isOpen ? 'Close menu' : 'Open menu');
    if (mainHeader) mainHeader.classList.toggle('is-mobile-menu-open', isOpen);
    if (mobileNavOverlay) {
      mobileNavOverlay.classList.toggle('mobile-nav-overlay--visible', isOpen);
      mobileNavOverlay.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    }
    if (isOpen) {
      updateHeaderBottom();
      if (!document.body.classList.contains('search-popup-open')) {
        document.body.style.overflow = 'hidden';
      }
    } else {
      if (!document.body.classList.contains('search-popup-open')) {
        document.body.style.overflow = '';
      }
      var openItems = navMenu.querySelectorAll('.nav-item.is-open');
      openItems.forEach(function(item) { item.classList.remove('is-open'); });
    }
    setMobileMenuIcon(isOpen);
  }

  if (mobileMenuToggle && navMenu) {
    mobileMenuToggle.addEventListener('click', function(e) {
      e.stopPropagation();
      var willOpen = !navMenu.classList.contains('active');
      setMobileNavOpen(willOpen);
    });

    if (mobileNavOverlay) {
      mobileNavOverlay.addEventListener('click', function() {
        if (navMenu.classList.contains('active')) setMobileNavOpen(false);
      });
    }

    mobileNavCloseButtons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        setMobileNavOpen(false);
      });
    });

    document.addEventListener('click', function(event) {
      var panel = mobileNavPanel || navMenu;
      var clickInside = panel.contains(event.target) || mobileMenuToggle.contains(event.target);
      if (!clickInside && navMenu.classList.contains('active')) {
        setMobileNavOpen(false);
      }
    });

    window.addEventListener('resize', function() {
      updateHeaderBottom();
      if (window.innerWidth > 1024 && navMenu.classList.contains('active')) {
        setMobileNavOpen(false);
      }
    });

    updateHeaderBottom();

    // Mobile mega menu tree behavior (accordion)
    navMenu.addEventListener('click', function(event) {
      if (window.innerWidth > 1024) return;
      var trigger = event.target.closest('.nav-link.has-dropdown');
      if (!trigger || !navMenu.contains(trigger)) return;
      var navItem = trigger.closest('.nav-item');
      if (!navItem) return;
      var mega = navItem.querySelector('.mega-menu');
      if (!mega) return;
      event.preventDefault();
      var willOpen = !navItem.classList.contains('is-open');
      var siblings = navItem.parentElement ? navItem.parentElement.querySelectorAll('.nav-item.is-open') : [];
      siblings.forEach(function(item) {
        if (item !== navItem) item.classList.remove('is-open');
      });
      navItem.classList.toggle('is-open', willOpen);
    });
  }

  function initTopHeaderBar(scope) {
    var topHeaderBar = scope && scope.matches && scope.matches('[data-top-header-bar]')
      ? scope
      : (scope && scope.querySelector ? scope.querySelector('[data-top-header-bar]') : null);

    if (!topHeaderBar) topHeaderBar = document.querySelector('[data-top-header-bar]');
    if (!topHeaderBar) return;

    var tickerRoot = topHeaderBar.querySelector('[data-top-header-ticker]');
    var ticker = tickerRoot ? tickerRoot.querySelector('.top-header-ticker') : null;
    var track = tickerRoot ? tickerRoot.querySelector('.top-header-ticker__track') : null;
    var templateHtml = null;

    if (track) {
      var seedSet = track.querySelector('.top-header-ticker__set');
      if (seedSet && seedSet.innerHTML) {
        track.dataset.tickerTemplate = seedSet.innerHTML;
      }
      templateHtml = track.dataset.tickerTemplate || '';
    }

    function readEdgePadding() {
      var value = getComputedStyle(topHeaderBar).getPropertyValue('--top-header-edge-padding').trim();
      return value || '12px';
    }

    function columnReserve(width) {
      return Math.max(0, Math.ceil(width)) + 12;
    }

    function syncTopHeaderLayout() {
      if (topHeaderBar.classList.contains('top-header--full-width-message')) {
        topHeaderBar.style.setProperty('--top-header-side-left', '0px');
        topHeaderBar.style.setProperty('--top-header-side-right', '0px');
        return;
      }

      var leftCol = topHeaderBar.querySelector('.top-header-left');
      var rightCol = topHeaderBar.querySelector('.top-header-right');
      var edgePad = readEdgePadding();
      var leftReserve = edgePad;
      var rightReserve = edgePad;

      if (leftCol && leftCol.offsetParent !== null && leftCol.children.length) {
        leftReserve = columnReserve(leftCol.getBoundingClientRect().width) + 'px';
      }

      if (rightCol && rightCol.offsetParent !== null && rightCol.children.length) {
        rightReserve = columnReserve(rightCol.getBoundingClientRect().width) + 'px';
      }

      topHeaderBar.style.setProperty('--top-header-side-left', leftReserve);
      topHeaderBar.style.setProperty('--top-header-side-right', rightReserve);
    }

    function buildSetHtml(containerWidth) {
      if (!templateHtml) return '';

      var measureHost = document.createElement('div');
      measureHost.style.cssText = 'position:absolute;left:-9999px;top:0;display:inline-flex;align-items:center;gap:2rem;white-space:nowrap;font-size:' + (getComputedStyle(topHeaderBar).getPropertyValue('--top-header-message-font-size').trim() || '14px') + ';font-weight:' + (getComputedStyle(topHeaderBar).getPropertyValue('--top-header-font-weight').trim() || '600') + ';';
      measureHost.innerHTML = templateHtml;
      document.body.appendChild(measureHost);

      var guard = 0;
      while (measureHost.offsetWidth < containerWidth && measureHost.childElementCount < 40 && guard < 12) {
        var nodes = Array.prototype.slice.call(measureHost.childNodes);
        nodes.forEach(function(node) {
          measureHost.appendChild(node.cloneNode(true));
        });
        guard += 1;
      }

      var html = measureHost.innerHTML;
      document.body.removeChild(measureHost);
      return html;
    }

    function syncTickerSets() {
      if (!ticker || !track || !templateHtml) return;

      syncTopHeaderLayout();

      var content = buildSetHtml(ticker.offsetWidth || 0);
      if (!content) return;

      track.innerHTML = '';

      var setOne = document.createElement('span');
      setOne.className = 'top-header-ticker__set';
      setOne.innerHTML = content;

      var setTwo = document.createElement('span');
      setTwo.className = 'top-header-ticker__set';
      setTwo.setAttribute('aria-hidden', 'true');
      setTwo.innerHTML = content;

      track.appendChild(setOne);
      track.appendChild(setTwo);

      track.style.animation = 'none';
      void track.offsetWidth;
      track.style.removeProperty('animation');
    }

    function syncTopHeader() {
      syncTopHeaderLayout();
      if (track && templateHtml) syncTickerSets();
    }

    syncTopHeader();

    if (topHeaderBar._topHeaderResizeHandler) {
      window.removeEventListener('resize', topHeaderBar._topHeaderResizeHandler);
    }

    var resizeTimer;
    topHeaderBar._topHeaderResizeHandler = function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(syncTopHeader, 120);
    };
    window.addEventListener('resize', topHeaderBar._topHeaderResizeHandler);

    if (typeof ResizeObserver !== 'undefined') {
      if (topHeaderBar._topHeaderObserver) {
        topHeaderBar._topHeaderObserver.disconnect();
      }

      topHeaderBar._topHeaderObserver = new ResizeObserver(function() {
        syncTopHeader();
      });
      topHeaderBar._topHeaderObserver.observe(topHeaderBar);
      var leftCol = topHeaderBar.querySelector('.top-header-left');
      var rightCol = topHeaderBar.querySelector('.top-header-right');
      if (leftCol) topHeaderBar._topHeaderObserver.observe(leftCol);
      if (rightCol) topHeaderBar._topHeaderObserver.observe(rightCol);
    }
  }

  initTopHeaderBar();

  if (isDesignMode && typeof document.addEventListener === 'function') {
    document.addEventListener('shopify:section:load', function(evt) {
      if (evt.target && evt.target.querySelector && evt.target.querySelector('[data-top-header-bar]')) {
        initTopHeaderBar(evt.target);
      }
    });
  }

  // Top header rotating messages
  (function() {
    var rotator = document.querySelector('[data-top-header-rotator]');
    if (!rotator) return;
    if (document.querySelector('[data-top-header-ticker]')) return;
    var items = Array.prototype.slice.call(rotator.querySelectorAll('.top-header-offer'));
    var rotationEnabled = rotator.getAttribute('data-rotate-enabled') === 'true';
    if (!items.length) return;

    if (!rotationEnabled || items.length <= 1) {
      items.forEach(function(item, idx) {
        item.classList.toggle('is-active', idx === 0);
        item.classList.remove('is-leaving');
      });
      return;
    }

    var index = 0;
    var seconds = parseInt(rotator.getAttribute('data-rotate-seconds'), 10) || 4;
    var delay = Math.max(2, seconds) * 1000;

    function show(i) {
      var previous = index;
      index = (i + items.length) % items.length;
      items[previous].classList.remove('is-active');
      items[previous].classList.add('is-leaving');
      items[index].classList.remove('is-leaving');
      items[index].classList.add('is-active');
      setTimeout(function() {
        items[previous].classList.remove('is-leaving');
      }, 440);
    }

    setInterval(function() {
      show(index + 1);
    }, delay);
  })();

  // Cart count updates via /cart.js
  function updateCartCount() {
    fetch('/cart.js')
      .then(function(response) { return response.json(); })
      .then(function(cart) {
        var cartCount = document.getElementById('cart-count');
        if (!cartCount) return;

        var newCount = cart.item_count;
        var oldCount = parseInt(cartCount.textContent, 10) || 0;
        if (newCount !== oldCount) {
          cartCount.textContent = newCount;
          cartCount.classList.add('updated');
          setTimeout(function() {
            cartCount.classList.remove('updated');
          }, 300);
        }
      })
      .catch(function(error) {
        console && console.error && console.error('Error updating cart count:', error);
      });
  }

  document.addEventListener('shopify:cart:updated', updateCartCount);
  window.addEventListener('cart:updated', updateCartCount);

  if (document.getElementById('cart-count')) {
    updateCartCount();
  }

  function safeFormatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents);
    }
    var amount = (cents / 100).toFixed(2);
    return '£' + amount;
  }

  function escapeHtml(value) {
    if (value === null || value === undefined) return '';
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function extractCartPropertyUrl(value) {
    var valStr = String(value || '').trim();
    if (!valStr) return '';
    var hrefMatch = valStr.match(/href\s*=\s*(["'])(.*?)\1/i);
    if (hrefMatch && hrefMatch[2]) return hrefMatch[2].trim();
    return valStr;
  }

  function isCartUploadPropertyKey(key) {
    var lowered = String(key || '').toLowerCase();
    return (
      lowered.indexOf('upload') !== -1 ||
      lowered.indexOf('file') !== -1 ||
      lowered.indexOf('artwork') !== -1 ||
      lowered.indexOf('image') !== -1
    );
  }

  function isCartPropertyFileUrl(url) {
    var lowered = String(url || '').toLowerCase();
    return (
      lowered.indexOf('http://') === 0 ||
      lowered.indexOf('https://') === 0 ||
      lowered.indexOf('/uploads/') !== -1 ||
      lowered.indexOf('/files/') !== -1 ||
      lowered.indexOf('cdn.shopify.com') !== -1 ||
      lowered.indexOf('shopifycdn.com') !== -1 ||
      lowered.indexOf('cloudlift.app') !== -1
    );
  }

  function isCartPropertyImageUrl(url, key) {
    var lowered = String(url || '').toLowerCase();
    if (/\.(jpe?g|png|gif|webp|svg|bmp|avif)(\?|$)/i.test(lowered)) {
      return true;
    }
    return isCartUploadPropertyKey(key) && isCartPropertyFileUrl(url);
  }

  function stripCartPropertyText(value) {
    return String(value || '').replace(/<[^>]*>/g, '').trim();
  }

  function openCartDrawer(cart) {
    var overlay = document.querySelector('[data-cart-overlay]');
    var drawer = document.getElementById('cart-drawer');
    if (!overlay || !drawer) return;

    var itemsContainer = drawer.querySelector('[data-cart-items]');
    var footer = drawer.querySelector('[data-cart-footer]');
    if (!itemsContainer || !footer) return;

    if (!cart || !cart.items || cart.items.length === 0) {
      itemsContainer.innerHTML = '<p>Your cart is currently empty.</p>';
      footer.innerHTML = '';
    } else {
      var html = '';
      var showOffer = drawer.getAttribute('data-cart-drawer-offer-enabled') === 'true';
      var offerText = drawer.getAttribute('data-cart-drawer-offer-text') || '';
      var showProducts = drawer.getAttribute('data-cart-drawer-products-enabled') === 'true';
      var productsHeading = drawer.getAttribute('data-cart-drawer-products-heading') || 'You may also like';
      var saleBadgeLabel = drawer.getAttribute('data-cart-drawer-sale-badge') || 'Discount';

      cart.items.forEach(function(item) {
        html += '<div class="cart-drawer__item">';
        if (item.image) {
          html += '<img src="' + item.image + '" alt="">';
        }
        html += '<div class="cart-drawer__info">';
        html += '<button type="button" class="cart-drawer__remove" data-cart-drawer-remove="' + item.key + '" aria-label="Remove item">&times;</button>';
          html += '<div class="cart-drawer__info-title">' + escapeHtml(item.product_title) + '</div>';
        if (
          (item.original_price && item.price && item.original_price > item.price) ||
          (item.line_level_discount_allocations && item.line_level_discount_allocations.length > 0) ||
          (item.discounts && item.discounts.length > 0)
        ) {
          html += '<div class="cart-drawer__sale-badge" aria-label="' + escapeHtml(saleBadgeLabel) + '">' + escapeHtml(saleBadgeLabel) + '</div>';
        }
        if (item.variant_title && item.variant_title !== 'Default Title') {
            html += '<div class="cart-drawer__info-variant">' + escapeHtml(item.variant_title) + '</div>';
        }
        if (item.properties) {
          Object.keys(item.properties).forEach(function (key) {
            if (!key || key.charAt(0) === '_') return;
            var val = item.properties[key];
            if (val === null || val === undefined || val === '') return;
            var valStr = String(val);
            var propUrl = extractCartPropertyUrl(valStr);
            html += '<div class="cart-drawer__property">';
            html += '<span class="cart-drawer__property-key">' + escapeHtml(key) + ':</span> ';
            if (isCartPropertyImageUrl(propUrl, key) && isCartPropertyFileUrl(propUrl)) {
              html +=
                '<a href="' +
                escapeHtml(propUrl) +
                '" target="_blank" rel="noopener" class="cart-drawer__property-upload cart-main__property-upload" aria-label="View ' +
                escapeHtml(key) +
                '">';
              html +=
                '<img src="' +
                escapeHtml(propUrl) +
                '" alt="' +
                escapeHtml(key) +
                '" class="cart-drawer__property-thumb cart-main__property-thumb" width="56" height="56" loading="lazy" onerror="this.closest(\'.cart-main__property-upload\').hidden=true;">';
              html += '</a>';
            } else if (isCartPropertyFileUrl(propUrl) || isCartUploadPropertyKey(key)) {
              html +=
                '<a href="' +
                escapeHtml(propUrl) +
                '" target="_blank" rel="noopener" class="cart-drawer__property-link">View file</a>';
            } else {
              html += '<span>' + escapeHtml(stripCartPropertyText(valStr)) + '</span>';
            }
            html += '</div>';
          });
        }
        var unitParts = '';
        if (item.original_price && item.price && item.original_price > item.price) {
          unitParts += '<s class="cart-drawer__compare-at">' + safeFormatMoney(item.original_price) + '</s> ';
        }
        unitParts += safeFormatMoney(item.price);
        html += '<div class="cart-drawer__info-meta">' + item.quantity + ' × ' + unitParts + '</div>';
        html += '</div></div>';
      });
      itemsContainer.innerHTML = html;

      var productsHtml = '';
      if (showProducts) {
        var products = getCartDrawerProductsData();
        if (products.length) {
          productsHtml += '<div class="cart-drawer__upsell">';
          productsHtml += '<div class="cart-drawer__upsell-title">' + escapeHtml(productsHeading) + '</div>';
          productsHtml += '<div class="cart-drawer__upsell-list">';
          products.forEach(function(p) {
            productsHtml += '<a class="cart-drawer__upsell-item" href="' + (p.url || '#') + '">';
            if (p.image) {
              productsHtml += '<img src="' + p.image + '" alt="">';
            }
            productsHtml += '<span class="cart-drawer__upsell-name">' + escapeHtml(p.title || '') + '</span>';
            productsHtml += '<span class="cart-drawer__upsell-price">' + safeFormatMoney(p.price || 0) + '</span>';
            productsHtml += '</a>';
          });
          productsHtml += '</div></div>';
        }
      }

      var offerHtml = '';
      if (showOffer && offerText) {
        offerHtml = '<div class="cart-drawer__offer">' + escapeHtml(offerText) + '</div>';
      }

      footer.innerHTML =
        offerHtml +
        productsHtml +
        '<div class="cart-drawer__subtotal">' +
          '<span>Subtotal</span>' +
          '<span>' + safeFormatMoney(cart.total_price) + '</span>' +
        '</div>' +
        '<div class="cart-drawer__buttons">' +
          '<a href="' + (window.routes && window.routes.cart_url || '/cart') + '" class="cart-drawer__view-cart">View cart</a>' +
          '<a href="' + (window.routes && window.routes.checkout_url || '/checkout') + '" class="cart-drawer__checkout">Check out</a>' +
        '</div>';
    }

    overlay.classList.add('cart-drawer-overlay--visible');
    drawer.classList.add('cart-drawer--open');
    var cartIcon = document.getElementById('cart-icon');
    if (cartIcon) cartIcon.setAttribute('aria-expanded', 'true');
  }

  function closeCartDrawer() {
    var overlay = document.querySelector('[data-cart-overlay]');
    var drawer = document.getElementById('cart-drawer');
    if (!overlay || !drawer) return;
    overlay.classList.remove('cart-drawer-overlay--visible');
    drawer.classList.remove('cart-drawer--open');
    var cartIcon = document.getElementById('cart-icon');
    if (cartIcon) cartIcon.setAttribute('aria-expanded', 'false');
  }

  function getCartDrawerProductsData() {
    var dataEl = document.getElementById('cart-drawer-products-data');
    if (!dataEl) return [];
    try {
      return JSON.parse(dataEl.textContent || '[]');
    } catch (e) {
      return [];
    }
  }

  // Position mega menu clearly below sticky header
  var navItems = document.querySelectorAll('.nav-item');
  navItems.forEach(function(navItem) {
    var megaMenu = navItem.querySelector('.mega-menu');
    if (!megaMenu) return;

    navItem.addEventListener('mouseenter', function() {
      var header = document.querySelector('.main-header');
      if (!header) return;
      var rect = header.getBoundingClientRect();
      var offset = 10;
      megaMenu.style.top = (rect.bottom + offset) + 'px';
    });
  });

  // Mega menu product carousel (optional auto-loop from theme editor, no arrows)
  (function initMegaPromoCarousels() {
    var carousels = document.querySelectorAll('[data-mega-promo-carousel]');
    if (!carousels.length) return;

    carousels.forEach(function(carousel) {
      var track = carousel.querySelector('[data-mega-promo-carousel-track]');
      if (!track) return;

      var autoplayEnabled = carousel.getAttribute('data-mega-promo-carousel-autoplay') !== 'false';

      var originals = Array.prototype.slice.call(
        track.querySelectorAll('.mega-menu-promo-product--carousel:not(.mega-menu-promo-product--carousel-clone)')
      );
      if (originals.length < 2) return;

      function canScroll() {
        return track.scrollWidth - track.clientWidth > 2;
      }

      if (!canScroll()) return;

      if (autoplayEnabled) {
        originals.forEach(function(slide) {
          var clone = slide.cloneNode(true);
          clone.classList.add('mega-menu-promo-product--carousel-clone');
          clone.setAttribute('aria-hidden', 'true');
          clone.removeAttribute('role');
          track.appendChild(clone);
        });
      }

      function getGap() {
        try {
          var gapValue = window.getComputedStyle(track).columnGap || window.getComputedStyle(track).gap;
          return parseFloat(gapValue) || 12;
        } catch (e) {
          return 12;
        }
      }

      function measureSetWidth() {
        var gap = getGap();
        var width = 0;
        for (var i = 0; i < originals.length; i++) {
          width += originals[i].offsetWidth;
          if (i < originals.length - 1) width += gap;
        }
        return width;
      }

      function getStep() {
        return (originals[0].offsetWidth || 152) + getGap();
      }

      if (!autoplayEnabled) return;

      var intervalMs = parseInt(carousel.getAttribute('data-mega-promo-carousel-interval'), 10) || 4000;
      var timer = null;
      var paused = false;
      var ticking = false;

      function loopTick() {
        if (paused || ticking || !canScroll()) return;
        ticking = true;
        var setWidth = measureSetWidth();
        var step = getStep();
        var next = track.scrollLeft + step;

        if (next >= setWidth - 1) {
          track.scrollLeft = next - setWidth;
          next = track.scrollLeft + step;
        }

        track.scrollTo({ left: next, behavior: 'smooth' });
        window.setTimeout(function() {
          ticking = false;
        }, 520);
      }

      function startAutoplay() {
        stopAutoplay();
        timer = setInterval(loopTick, intervalMs);
      }

      function stopAutoplay() {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      }

      var navItem = carousel.closest('.nav-item');

      track.addEventListener('mouseenter', function() {
        paused = true;
        stopAutoplay();
      });
      track.addEventListener('mouseleave', function() {
        paused = false;
        if (navItem && navItem.matches(':hover')) startAutoplay();
      });

      if (navItem) {
        navItem.addEventListener('mouseenter', function() {
          paused = false;
          startAutoplay();
        });
        navItem.addEventListener('mouseleave', function() {
          paused = true;
          stopAutoplay();
          track.scrollLeft = 0;
        });
      }

      window.addEventListener('resize', function() {
        if (!canScroll()) stopAutoplay();
      });
    });
  })();

  // Product-card color swatches: click swaps the card image to the variant image
  (function initProductCardSwatches() {
    function findCardImage(card) {
      if (!card) return null;
      return (
        card.querySelector('[data-product-card-image]') ||
        card.querySelector('.product-card__image:not(.product-card__image--hover)') ||
        card.querySelector('.mogi-product-card__image--primary') ||
        card.querySelector('.mogi-product-card__image')
      );
    }

    function activate(card, swatch) {
      if (!card || !swatch) return;
      var image = findCardImage(card);
      var variantImage = swatch.getAttribute('data-variant-image');
      if (image && variantImage) {
        image.src = variantImage;
        if (image.srcset) image.removeAttribute('srcset');
        if (image.sizes) image.removeAttribute('sizes');
      }

      var variantUrl = swatch.getAttribute('data-variant-url');
      if (variantUrl) {
        var links = card.querySelectorAll('a[href]');
        links.forEach(function(link) {
          if (link.closest('[data-product-card-swatches]')) return;
          if (link.classList.contains('wishlist-toggle')) return;
          link.setAttribute('href', variantUrl);
        });
      }

      var siblings = card.querySelectorAll('[data-product-card-swatch]');
      siblings.forEach(function(s) {
        s.classList.toggle('is-active', s === swatch);
        s.setAttribute('aria-pressed', s === swatch ? 'true' : 'false');
      });
    }

    document.addEventListener('click', function(evt) {
      var swatch = evt.target.closest && evt.target.closest('[data-product-card-swatch]');
      if (!swatch) return;
      evt.preventDefault();
      evt.stopPropagation();
      var card =
        swatch.closest('.product-card') ||
        swatch.closest('.mogi-product-card') ||
        swatch.closest('[data-product-card]');
      activate(card, swatch);
    });
  })();

  // Product gallery (thumbs, video, lightbox)
  function initProductGallery(productRoot, options) {
    var gallery = productRoot.querySelector('[data-product-gallery]');
    var mediaNode = productRoot.querySelector('[data-product-gallery-media]');
    if (!gallery || !mediaNode) return null;

    var media = [];
    try { media = JSON.parse(mediaNode.textContent || '[]'); } catch (e) { return null; }
    if (!media.length) return null;

    options = options || {};
    var enableZoom = options.enableZoom === true;
    var lightboxOn = options.lightboxOn || 'all';
    var mobileMq = window.matchMedia('(max-width: 749px)');

    var thumbTrack = gallery.querySelector('[data-thumb-track]');
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('.product-gallery__thumb'));
    var main = gallery.querySelector('[data-gallery-main]');
    var mainImage = gallery.querySelector('[data-gallery-image]');
    var posterImage = gallery.querySelector('[data-gallery-poster]');
    var mainVideo = gallery.querySelector('[data-gallery-video]');
    var embedEl = gallery.querySelector('[data-gallery-embed]');
    var playOverlay = gallery.querySelector('[data-gallery-play]');
    var lightbox = productRoot.querySelector('[data-product-gallery-lightbox]');
    var lbViewport = lightbox ? lightbox.querySelector('[data-lightbox-viewport]') : null;
    var lbImage = lightbox ? lightbox.querySelector('[data-lightbox-image]') : null;
    var lbCounter = lightbox ? lightbox.querySelector('[data-lightbox-counter]') : null;
    var lbStatus = lightbox ? lightbox.querySelector('[data-lightbox-status]') : null;
    var lbStatusText = lightbox ? lightbox.querySelector('[data-lightbox-status-text]') : null;
    var lbLoadingText = lbStatusText ? lbStatusText.textContent : 'Loading image…';

    function isMobileViewport() {
      return mobileMq.matches;
    }

    function isLightboxEnabledForViewport() {
      if (!enableZoom || !lightbox) return false;
      if (lightboxOn === 'off' || lightboxOn === 'none') return false;
      if (lightboxOn === 'desktop') return !isMobileViewport();
      if (lightboxOn === 'mobile') return isMobileViewport();
      return true;
    }

    function applyLightboxCursor() {
      if (!main) return;
      main.style.cursor = isLightboxEnabledForViewport() && !gallery.classList.contains('is-video-active') && !gallery.classList.contains('is-embed-active')
        ? 'zoom-in'
        : '';
    }

    var index = parseInt(gallery.getAttribute('data-gallery-active-index') || '0', 10);
    if (isNaN(index) || index < 0) index = 0;

    var lbScale = 1;
    var lbPanX = 0;
    var lbPanY = 0;
    var lbDragging = false;
    var lbDragStartX = 0;
    var lbDragStartY = 0;
    var lbPanStartX = 0;
    var lbPanStartY = 0;
    var LB_MIN_SCALE = 1;
    var LB_MAX_SCALE = 4;
    var galleryKeyHandler = null;
    var bodyScrollLockY = 0;

    if (lightbox && lightbox.parentElement !== document.body) {
      document.body.appendChild(lightbox);
    }

    function lockBodyScroll() {
      bodyScrollLockY = window.scrollY || window.pageYOffset || 0;
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + bodyScrollLockY + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
      document.body.classList.add('gallery-lightbox-open');
    }

    function unlockBodyScroll() {
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      document.body.classList.remove('gallery-lightbox-open');
      window.scrollTo(0, bodyScrollLockY);
    }

    function isImageItem(item) {
      return item && item.type === 'image';
    }

    function isLightboxItem(item) {
      return isImageItem(item);
    }

    function resetLbView() {
      if (!lightbox || !lbImage) return;
      lbScale = 1;
      lbPanX = 0;
      lbPanY = 0;
      lbDragging = false;
      lightbox.classList.remove('is-zoomed', 'is-dragging');
      applyLbTransform();
    }

    function applyLbTransform() {
      if (!lightbox || !lbImage) return;
      lbImage.style.transform = 'translate(' + lbPanX + 'px, ' + lbPanY + 'px) scale(' + lbScale + ')';
      lightbox.classList.toggle('is-zoomed', lbScale > 1);
    }

    function clampLbPan() {
      if (!lbViewport || !lbImage || lbScale <= 1) {
        lbPanX = 0;
        lbPanY = 0;
        return;
      }
      var baseW = lbImage.offsetWidth;
      var baseH = lbImage.offsetHeight;
      var scaledW = baseW * lbScale;
      var scaledH = baseH * lbScale;
      var maxX = Math.max(0, (scaledW - lbViewport.clientWidth) / 2);
      var maxY = Math.max(0, (scaledH - lbViewport.clientHeight) / 2);
      lbPanX = Math.min(maxX, Math.max(-maxX, lbPanX));
      lbPanY = Math.min(maxY, Math.max(-maxY, lbPanY));
    }

    function setLbZoom(nextScale, clientX, clientY) {
      if (!lightbox || !lbImage) return;
      var oldScale = lbScale;
      var newScale = Math.min(LB_MAX_SCALE, Math.max(LB_MIN_SCALE, nextScale));
      if (newScale === oldScale) return;

      if (typeof clientX === 'number' && typeof clientY === 'number') {
        var rect = lbImage.getBoundingClientRect();
        var centerX = rect.left + rect.width / 2;
        var centerY = rect.top + rect.height / 2;
        var offsetX = clientX - centerX;
        var offsetY = clientY - centerY;
        var ratio = newScale / oldScale;
        lbPanX = (lbPanX - offsetX) * ratio + offsetX;
        lbPanY = (lbPanY - offsetY) * ratio + offsetY;
      }

      lbScale = newScale;
      if (lbScale <= 1) {
        lbPanX = 0;
        lbPanY = 0;
      } else {
        clampLbPan();
      }
      applyLbTransform();
    }

    function startLbDrag(clientX, clientY) {
      if (lbScale <= 1) return;
      lbDragging = true;
      lightbox.classList.add('is-dragging');
      lbDragStartX = clientX;
      lbDragStartY = clientY;
      lbPanStartX = lbPanX;
      lbPanStartY = lbPanY;
    }

    function moveLbDrag(clientX, clientY) {
      if (!lbDragging) return;
      lbPanX = lbPanStartX + (clientX - lbDragStartX);
      lbPanY = lbPanStartY + (clientY - lbDragStartY);
      clampLbPan();
      applyLbTransform();
    }

    function endLbDrag() {
      if (!lbDragging) return;
      lbDragging = false;
      lightbox.classList.remove('is-dragging');
    }

    function clearStageMedia() {
      if (mainImage) mainImage.hidden = true;
      if (posterImage) posterImage.hidden = true;
      if (mainVideo) {
        mainVideo.pause();
        mainVideo.removeAttribute('src');
        mainVideo.load();
        mainVideo.controls = false;
        mainVideo.hidden = true;
      }
      if (embedEl) {
        embedEl.hidden = true;
        embedEl.innerHTML = '';
      }
      gallery.classList.remove('is-video-active', 'is-embed-active', 'is-playing');
    }

    function setActiveThumb(i) {
      thumbs.forEach(function(thumb, ti) {
        thumb.classList.toggle('is-active', ti === i);
      });
      if (thumbTrack && thumbs[i]) {
        thumbs[i].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
    }

    function showEmbed(item) {
      clearStageMedia();
      gallery.classList.add('is-embed-active');
      if (!embedEl) return;
      embedEl.hidden = false;
      var tpl = gallery.querySelector('[data-gallery-embed-template="' + item.templateId + '"]');
      if (tpl && tpl.content) {
        embedEl.appendChild(tpl.content.cloneNode(true));
      }
    }

    function showMedia(i, thumbOptions) {
      index = (i + media.length) % media.length;
      var item = media[index];
      clearStageMedia();
      setActiveThumb(index);

      if (item.type === 'video' && item.src && mainVideo) {
        gallery.classList.add('is-video-active');
        if (posterImage) {
          posterImage.hidden = false;
          posterImage.src = item.poster || item.thumb || '';
          posterImage.alt = item.alt || '';
        }
        mainVideo.poster = item.poster || item.thumb || '';
        mainVideo.src = item.src;
        mainVideo.currentTime = 0;
      } else if (item.templateId) {
        showEmbed(item);
      } else if (mainImage) {
        mainImage.hidden = false;
        mainImage.src = item.src || item.thumb || '';
        mainImage.alt = item.alt || '';
      }

      if (lightbox && lightbox.classList.contains('is-open') && isLightboxItem(item)) {
        updateLightboxImage();
      }
      applyLightboxCursor();
    }

    function playInlineVideo() {
      var item = media[index];
      if (!item || item.type !== 'video' || !mainVideo || !item.src) return;
      mainVideo.src = item.src;
      mainVideo.load();
      gallery.classList.add('is-playing');
      mainVideo.hidden = false;
      mainVideo.controls = true;
      mainVideo.play().catch(function() {
        gallery.classList.remove('is-playing');
        mainVideo.hidden = true;
        mainVideo.controls = false;
      });
    }

    function setLightboxLoading(isLoading, message) {
      if (!lightbox) return;
      lightbox.classList.toggle('is-loading', isLoading);
      if (lbStatus) lbStatus.hidden = !isLoading;
      if (lbStatusText && message) lbStatusText.textContent = message;
      else if (lbStatusText && isLoading) lbStatusText.textContent = lbLoadingText;
    }

    function updateLightboxImage() {
      if (!lightbox || !lbImage || !lbCounter) return;
      var item = media[index];
      if (!isLightboxItem(item)) return;

      var primarySrc = item.zoom || item.src || item.thumb || '';
      var fallbackSrc = item.src || item.thumb || '';
      if (!primarySrc && mainImage && mainImage.src) primarySrc = mainImage.src;
      if (!primarySrc) return;

      endLbDrag();
      resetLbView();
      lbCounter.textContent = (index + 1) + ' / ' + media.length;
      lbImage.alt = item.alt || '';

      setLightboxLoading(true);
      lbImage.hidden = true;
      lbImage.removeAttribute('width');
      lbImage.removeAttribute('height');

      function revealImage() {
        setLightboxLoading(false);
        lbImage.hidden = false;
        resetLbView();
      }

      function showLoadError() {
        setLightboxLoading(true, 'Image could not load');
      }

      function loadLightboxSrc(srcUrl, allowFallback) {
        lbImage.onload = function() {
          lbImage.onload = null;
          lbImage.onerror = null;
          revealImage();
        };
        lbImage.onerror = function() {
          lbImage.onload = null;
          lbImage.onerror = null;
          if (allowFallback && fallbackSrc && srcUrl !== fallbackSrc) {
            loadLightboxSrc(fallbackSrc, false);
            return;
          }
          showLoadError();
        };
        lbImage.src = srcUrl;
        if (lbImage.complete && lbImage.naturalWidth > 0) {
          lbImage.onload = null;
          lbImage.onerror = null;
          revealImage();
        }
      }

      loadLightboxSrc(primarySrc, true);
    }

    function openLightbox() {
      if (!isLightboxEnabledForViewport() || !lightbox) return;
      var item = media[index];
      if (!isLightboxItem(item)) return;
      lightbox.classList.add('is-open');
      lightbox.setAttribute('aria-hidden', 'false');
      lockBodyScroll();
      updateLightboxImage();
    }

    function closeLightbox() {
      if (!lightbox) return;
      lightbox.classList.remove('is-open', 'is-loading');
      lightbox.setAttribute('aria-hidden', 'true');
      unlockBodyScroll();
      if (lbStatus) lbStatus.hidden = true;
      if (lbImage) {
        lbImage.hidden = true;
        lbImage.onload = null;
        lbImage.onerror = null;
      }
      endLbDrag();
      resetLbView();
    }

    function moveLightbox(step) {
      var nextIndex = (index + step + media.length) % media.length;
      if (!isLightboxItem(media[nextIndex])) {
        closeLightbox();
        showMedia(nextIndex);
        return;
      }
      showMedia(nextIndex);
      updateLightboxImage();
    }

    function showByMediaId(mediaId) {
      var id = String(mediaId);
      for (var i = 0; i < media.length; i++) {
        if (String(media[i].id) === id) {
          showMedia(i);
          return true;
        }
      }
      return false;
    }

    function showFallbackImage(src, alt) {
      if (!mainImage || !src) return false;
      clearStageMedia();
      mainImage.hidden = false;
      mainImage.src = src;
      mainImage.alt = alt || '';
      return true;
    }

    thumbs.forEach(function(thumb, i) {
      thumb.addEventListener('click', function() { showMedia(i); });
    });

    var galleryPrev = gallery.querySelector('[data-gallery-prev]');
    var galleryNext = gallery.querySelector('[data-gallery-next]');
    if (galleryPrev) {
      galleryPrev.addEventListener('click', function() { showMedia(index - 1); });
    }
    if (galleryNext) {
      galleryNext.addEventListener('click', function() { showMedia(index + 1); });
    }

    if (thumbTrack) {
      thumbTrack.addEventListener('wheel', function(e) {
        e.preventDefault();
        var isRow = window.matchMedia('(max-width: 749px)').matches;
        thumbTrack.scrollBy({ top: isRow ? 0 : e.deltaY, left: isRow ? e.deltaY : 0, behavior: 'auto' });
      }, { passive: false });
    }

    if (playOverlay) {
      playOverlay.addEventListener('click', function(evt) {
        evt.stopPropagation();
        playInlineVideo();
      });
    }

    if (mainVideo) {
      mainVideo.addEventListener('click', function(evt) { evt.stopPropagation(); });
      mainVideo.addEventListener('ended', function() {
        gallery.classList.remove('is-playing');
        mainVideo.controls = false;
        mainVideo.hidden = true;
        if (posterImage) posterImage.hidden = false;
      });
    }

    if (main) {
      main.addEventListener('click', function(evt) {
        if (evt.target.closest('.product-gallery__nav, .product-gallery__play-overlay, [data-gallery-video], .product-gallery__embed')) return;
        if (isLightboxEnabledForViewport() && isLightboxItem(media[index])) openLightbox();
      });
    }

    if (lightbox) {
      var lbClose = lightbox.querySelector('[data-lightbox-close]');
      var lbPrev = lightbox.querySelector('[data-lightbox-prev]');
      var lbNext = lightbox.querySelector('[data-lightbox-next]');
      var lbZoomIn = lightbox.querySelector('[data-lightbox-zoom-in]');
      var lbZoomOut = lightbox.querySelector('[data-lightbox-zoom-out]');
      var lbZoomReset = lightbox.querySelector('[data-lightbox-zoom-reset]');

      if (lbClose) lbClose.addEventListener('click', closeLightbox);
      if (lbPrev) {
        lbPrev.addEventListener('click', function(evt) {
          evt.stopPropagation();
          moveLightbox(-1);
        });
      }
      if (lbNext) {
        lbNext.addEventListener('click', function(evt) {
          evt.stopPropagation();
          moveLightbox(1);
        });
      }
      lightbox.addEventListener('click', function(evt) {
        if (evt.target === lightbox) closeLightbox();
      });
      lightbox.addEventListener('wheel', function(evt) {
        if (!lightbox.classList.contains('is-open')) return;
        if (evt.target.closest('.gallery-lightbox__toolbar, .gallery-lightbox__close, .gallery-lightbox__nav')) return;
        evt.preventDefault();
        var delta = evt.deltaY > 0 ? -0.15 : 0.15;
        setLbZoom(lbScale + delta, evt.clientX, evt.clientY);
      }, { passive: false });

      var lbSwipeStartX = 0;
      var lbSwipeStartY = 0;
      var lbSwipeActive = false;

      if (lbViewport) {
        lbViewport.addEventListener('touchstart', function(evt) {
          if (!lightbox.classList.contains('is-open') || lbScale > 1 || evt.touches.length !== 1) return;
          lbSwipeStartX = evt.touches[0].clientX;
          lbSwipeStartY = evt.touches[0].clientY;
          lbSwipeActive = true;
        }, { passive: true });

        lbViewport.addEventListener('touchend', function(evt) {
          if (!lbSwipeActive || !evt.changedTouches.length) return;
          lbSwipeActive = false;
          if (lbScale > 1) return;
          var dx = evt.changedTouches[0].clientX - lbSwipeStartX;
          var dy = evt.changedTouches[0].clientY - lbSwipeStartY;
          if (Math.abs(dx) < 50 || Math.abs(dx) < Math.abs(dy) * 1.2) return;
          if (dx > 0) moveLightbox(-1);
          else moveLightbox(1);
        }, { passive: true });
      }

      if (lbImage) {
        lbImage.addEventListener('dblclick', function(evt) {
          if (!lightbox.classList.contains('is-open')) return;
          if (lbScale > 1) resetLbView();
          else setLbZoom(2, evt.clientX, evt.clientY);
        });
        lbImage.addEventListener('mousedown', function(evt) {
          if (evt.button !== 0 || lbScale <= 1) return;
          evt.preventDefault();
          startLbDrag(evt.clientX, evt.clientY);
        });
        lbImage.addEventListener('touchstart', function(evt) {
          if (lbScale <= 1 || evt.touches.length !== 1) return;
          startLbDrag(evt.touches[0].clientX, evt.touches[0].clientY);
        }, { passive: true });
      }

      if (lbZoomIn) lbZoomIn.addEventListener('click', function() { setLbZoom(lbScale + 0.25); });
      if (lbZoomOut) lbZoomOut.addEventListener('click', function() { setLbZoom(lbScale - 0.25); });
      if (lbZoomReset) lbZoomReset.addEventListener('click', resetLbView);

      window.addEventListener('mousemove', function(evt) { moveLbDrag(evt.clientX, evt.clientY); });
      window.addEventListener('mouseup', endLbDrag);
      window.addEventListener('touchmove', function(evt) {
        if (!lbDragging || evt.touches.length !== 1) return;
        evt.preventDefault();
        moveLbDrag(evt.touches[0].clientX, evt.touches[0].clientY);
      }, { passive: false });
      window.addEventListener('touchend', endLbDrag);

      window.addEventListener('resize', function() {
        if (lightbox && lightbox.classList.contains('is-open') && !isLightboxEnabledForViewport()) {
          closeLightbox();
        }
      });
    }

    galleryKeyHandler = function(evt) {
      if (lightbox && lightbox.classList.contains('is-open')) {
        if (evt.key === 'Escape') closeLightbox();
        if (evt.key === 'ArrowLeft') {
          evt.preventDefault();
          moveLightbox(-1);
        }
        if (evt.key === 'ArrowRight') {
          evt.preventDefault();
          moveLightbox(1);
        }
        return;
      }
      if (evt.target && evt.target.closest && evt.target.closest('input, textarea, select')) return;
      if (evt.key === 'ArrowLeft') showMedia(index - 1);
      if (evt.key === 'ArrowRight') showMedia(index + 1);
    };
    document.addEventListener('keydown', galleryKeyHandler);

    function onLightboxViewportChange() {
      applyLightboxCursor();
      if (lightbox && lightbox.classList.contains('is-open') && !isLightboxEnabledForViewport()) {
        closeLightbox();
      }
    }

    if (mobileMq.addEventListener) {
      mobileMq.addEventListener('change', onLightboxViewportChange);
    } else if (mobileMq.addListener) {
      mobileMq.addListener(onLightboxViewportChange);
    }

    showMedia(index, { initial: true });
    applyLightboxCursor();

    return {
      showMedia: showMedia,
      showByMediaId: showByMediaId,
      showFallbackImage: showFallbackImage,
      destroy: function() {
        if (galleryKeyHandler) document.removeEventListener('keydown', galleryKeyHandler);
        closeLightbox();
      }
    };
  }

  // Advanced product interactions (media, variants, sticky ATC)
  (function() {
    var productRoot = document.querySelector('[data-product-root]');
    if (!productRoot) return;

    var mainImage = productRoot.querySelector('[data-product-main-image]');
    var form = productRoot.querySelector('[data-product-form]');
    var variantSelect = productRoot.querySelector('[data-variant-id-select]');
    var variantInput = productRoot.querySelector('[data-variant-id-input]');
    var variantInputs = Array.prototype.slice.call(productRoot.querySelectorAll('[data-variant-id-input]'));
    var optionInputs = Array.prototype.slice.call(productRoot.querySelectorAll('[data-variant-option-input]'));
    var stickySubmit = productRoot.querySelector('[data-product-sticky-submit]');
    var stickyPrice = productRoot.querySelector('[data-product-sticky-price]');
    var skuEl = productRoot.querySelector('[data-product-sku]');
    var inventoryWrap = productRoot.querySelector('[data-product-inventory]');
    var addToCartBtn = productRoot.querySelector('.product-main__add-to-cart');
    var enableZoom = productRoot.getAttribute('data-enable-image-zoom') === 'true';
    var lightboxOn = productRoot.getAttribute('data-image-lightbox-on') || 'all';
    var galleryApi = initProductGallery(productRoot, { enableZoom: enableZoom, lightboxOn: lightboxOn });
    var variantsJsonNode = productRoot.querySelector('[data-product-variants-json]');
    var variants = [];
    try { variants = JSON.parse(variantsJsonNode ? variantsJsonNode.textContent : '[]'); } catch (e) {}

    function setMediaForVariant(variant) {
      if (!variant) return;
      if (galleryApi) {
        if (variant.featured_media && variant.featured_media.id && galleryApi.showByMediaId(variant.featured_media.id)) {
          return;
        }
        if (variant.featured_image && variant.featured_image.src && galleryApi.showFallbackImage(variant.featured_image.src, variant.featured_image.alt)) {
          return;
        }
      }
      if (mainImage && variant.featured_image && variant.featured_image.src) {
        mainImage.setAttribute('src', variant.featured_image.src);
        if (variant.featured_image.alt) mainImage.setAttribute('alt', variant.featured_image.alt);
      }
    }

    function findVariantFromOptions() {
      if (!optionInputs.length || !variants.length) return null;
      var selectedOptions = getSelectedOptionsByIndex();
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var ok = true;
        for (var j = 0; j < selectedOptions.length; j++) {
          if (selectedOptions[j] && selectedOptions[j] !== v.options[j]) {
            ok = false;
            break;
          }
        }
        if (ok) return v;
      }
      return null;
    }

    function findVariantById(id) {
      if (!variants.length || !id) return null;
      var variantId = String(id);
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === variantId) return variants[i];
      }
      return null;
    }

    function setInventoryState(variant) {
      if (!inventoryWrap || !variant) return;
      var qty = typeof variant.inventory_quantity === 'number' ? variant.inventory_quantity : null;
      inventoryWrap.innerHTML = '';
      if (!variant.available) {
        inventoryWrap.innerHTML = '<span class="product-main__inventory-status product-main__inventory-status--sold-out">Sold out</span>';
      } else if (qty !== null && qty > -1 && qty <= 5) {
        inventoryWrap.innerHTML = '<span class="product-main__inventory-status product-main__inventory-status--low">Only ' + qty + ' left</span>';
      }
    }

    function getCurrentVariantModel() {
      if (variantSelect && variantSelect.value) {
        var vs = findVariantById(variantSelect.value);
        if (vs) return vs;
      }
      if (variantInput && variantInput.value) {
        var vi = findVariantById(variantInput.value);
        if (vi) return vi;
      }
      if (optionInputs.length) {
        var vo = findVariantFromOptions();
        if (vo) return vo;
      }
      return variants[0] || null;
    }

    function parseMoneyToCents(text) {
      if (!text) return null;
      var t = String(text).replace(/,/g, '');
      if (/%/.test(t) && !/[£$€]/.test(t) && !/\d+\.\d{1,2}/.test(t)) return null;
      var moneyMatch = t.match(/[£$€]\s*(\d+(?:\.\d{1,2})?)/);
      if (!moneyMatch) moneyMatch = t.match(/(\d+\.\d{1,2})(?:\s*(?:each|ea|per))?/i);
      if (!moneyMatch) return null;
      var n = parseFloat(moneyMatch[1]);
      if (isNaN(n)) return null;
      return Math.round(n * 100);
    }

    function parseQtyRangeFromText(s) {
      s = (s || '').trim();
      var m = s.match(/(\d+)\s*[-–]\s*(\d+)/);
      if (m) return { min: parseInt(m[1], 10), max: parseInt(m[2], 10) };
      m = s.match(/(\d+)\s*\+/);
      if (m) return { min: parseInt(m[1], 10), max: 2147483647 };
      m = s.match(/(\d+)/);
      if (m) {
        var single = parseInt(m[1], 10);
        if (!isNaN(single)) return { min: single, max: single };
      }
      return null;
    }

    function findBulkDiscountTable(root) {
      function tableMatches(t) {
        if (!t || (t.closest && t.closest('.product-main__tiers'))) return false;
        var txt = (t.textContent || '').toLowerCase();
        return /discounted\s*rate|buy\s*\d|quantity|bulk|discount|dealeasy|volume/.test(txt);
      }
      var anchor = root.querySelector('[data-volume-discount-anchor]');
      if (anchor) {
        var inAnchor = anchor.querySelectorAll('table');
        for (var a = 0; a < inAnchor.length; a++) {
          if (tableMatches(inAnchor[a])) return inAnchor[a];
        }
      }
      var widgetSelectors = [
        '[class*="dealeasy"]',
        '[id*="dealeasy"]',
        '[class*="lb-volume-discount"]',
        '[id*="volume-discount"]'
      ];
      var w;
      for (w = 0; w < widgetSelectors.length; w++) {
        var widget = root.querySelector(widgetSelectors[w]);
        if (!widget) continue;
        var widgetTables = widget.querySelectorAll('table');
        for (var wt = 0; wt < widgetTables.length; wt++) {
          if (tableMatches(widgetTables[wt])) return widgetTables[wt];
        }
      }
      var tables = root.querySelectorAll('table');
      for (var i = 0; i < tables.length; i++) {
        if (tableMatches(tables[i])) return tables[i];
      }
      return null;
    }

    function parseBulkTiers(table) {
      if (!table) return [];
      var rows = table.querySelectorAll('tbody tr');
      if (!rows.length) rows = table.querySelectorAll('tr');
      var tiers = [];
      Array.prototype.forEach.call(rows, function(tr) {
        if (tr.querySelector('th')) return;
        var cells = tr.querySelectorAll('td');
        if (cells.length < 2) return;
        var rangeText = (cells[0].textContent || '').trim();
        var rng = parseQtyRangeFromText(rangeText);
        if (!rng) return;
        var rateCell = cells[cells.length - 1];
        var cents = parseMoneyToCents(rateCell.textContent);
        if (cents == null) return;
        var discountPercent = null;
        if (cells.length >= 3) {
          var pctMatch = (cells[1].textContent || '').match(/(\d+)\s*%/);
          if (pctMatch) discountPercent = parseInt(pctMatch[1], 10);
        }
        tiers.push({ min: rng.min, max: rng.max, unitCents: cents, discountPercent: discountPercent });
      });
      tiers.sort(function(a, b) { return a.min - b.min; });
      return tiers;
    }

    var bulkTiersCache = [];
    var appBulkTiersCache = [];

    function loadDisplayBulkTiers() {
      var tiers = [];
      if (productRoot.getAttribute('data-apply-tier-pricing-display') === 'true') {
        tiers = parseThemeTierPricing(productRoot);
      }
      if (!tiers.length) {
        tiers = parseBulkTiers(findBulkDiscountTable(productRoot));
      }
      return tiers;
    }

    function refreshBulkTiersCache() {
      bulkTiersCache = loadDisplayBulkTiers();
    }

    function refreshAppBulkTiersCache() {
      appBulkTiersCache = loadDisplayBulkTiers();
    }

    function formatTierRange(tier) {
      if (!tier) return '';
      if (tier.max >= 2147483647) return String(tier.min) + '+';
      if (tier.min === tier.max) return String(tier.min);
      return tier.min + '–' + tier.max;
    }

    function tierForQty(qty, tiers) {
      if (!tiers || !tiers.length || qty < 1) return null;
      var match = null;
      for (var i = 0; i < tiers.length; i++) {
        var t = tiers[i];
        if (qty >= t.min && qty <= t.max && (!match || t.min > match.min)) {
          match = t;
        }
      }
      return match;
    }

    function applyBulkMessageTemplate(template, values) {
      var text = template || '';
      Object.keys(values).forEach(function(key) {
        text = text.replace(new RegExp('\\[' + key + '\\]', 'g'), values[key]);
      });
      return text;
    }

    function updateBulkSavingsSummary(variant, qty) {
      var wrap = productRoot.querySelector('[data-product-bulk-savings]');
      if (!wrap || !variant) return;
      refreshAppBulkTiersCache();
      var tier = tierForQty(qty, appBulkTiersCache);
      var rateEl = wrap.querySelector('[data-product-bulk-savings-rate]');
      var saveEl = wrap.querySelector('[data-product-bulk-savings-save]');
      if (!rateEl || !saveEl) return;
      var base = variant.price || 0;
      if (!tier || base <= 0) {
        wrap.hidden = true;
        rateEl.textContent = '';
        saveEl.textContent = '';
        return;
      }
      var fullLine = base * qty;
      var savings = 0;
      var percent = tier.discountPercent;
      if (percent != null && percent > 0 && percent < 100) {
        savings = Math.round(fullLine * percent / 100);
      } else if (tier.unitCents > 0 && tier.unitCents < base) {
        savings = (base - tier.unitCents) * qty;
        if (percent == null) {
          percent = Math.round(((base - tier.unitCents) / base) * 100);
        }
      }
      if (savings <= 0 || savings >= fullLine) {
        wrap.hidden = true;
        rateEl.textContent = '';
        saveEl.textContent = '';
        return;
      }
      var savingsFormatted = safeFormatMoney(savings);
      var values = {
        unit: tier.unitCents > 0 ? safeFormatMoney(tier.unitCents) : safeFormatMoney(base),
        range: formatTierRange(tier),
        quantity: String(qty),
        savings: savingsFormatted,
        save: savingsFormatted,
        saved: savingsFormatted,
        amount: savingsFormatted,
        percent: percent != null ? String(percent) : ''
      };
      wrap.hidden = false;
      rateEl.textContent = applyBulkMessageTemplate(wrap.getAttribute('data-bulk-rate-message'), values);
      saveEl.textContent = applyBulkMessageTemplate(wrap.getAttribute('data-bulk-save-message'), values);
    }

    function parseThemeTierPricing(root) {
      var wrap = root.querySelector('[data-tier-pricing]');
      if (!wrap) return [];
      var qtyCells = wrap.querySelectorAll('.product-main__tier-cell--qty[data-tier-min]');
      var priceCells = wrap.querySelectorAll('.product-main__tier-cell--price');
      var tiers = [];
      Array.prototype.forEach.call(qtyCells, function(qtyCell, idx) {
        var min = parseInt(qtyCell.getAttribute('data-tier-min'), 10);
        var priceCell = priceCells[idx];
        var cents = priceCell ? parseMoneyToCents(priceCell.textContent) : null;
        if (isNaN(min) || cents == null) return;
        tiers.push({ min: min, max: 2147483647, unitCents: cents });
      });
      tiers.sort(function(a, b) { return a.min - b.min; });
      for (var i = 0; i < tiers.length; i++) {
        tiers[i].max = i < tiers.length - 1 ? tiers[i + 1].min - 1 : 2147483647;
      }
      return tiers;
    }

    function tierUnitCentsForQty(qty, tiers) {
      if (!tiers || !tiers.length || qty < 1) return null;
      var match = null;
      for (var i = 0; i < tiers.length; i++) {
        var t = tiers[i];
        if (qty >= t.min && qty <= t.max && (!match || t.min > match.min)) {
          match = t;
        }
      }
      return match ? match.unitCents : null;
    }

    function getVariantDisplayUnitCents(variant, tierUnitCents) {
      if (!variant) return 0;
      var base = variant.price || 0;
      if (tierUnitCents != null && tierUnitCents < base) return tierUnitCents;
      return base;
    }

    function renderProductPrice(variant, tierUnitCents) {
      if (!variant) return;
      var base = variant.price || 0;
      var ca = variant.compare_at_price;
      var display = getVariantDisplayUnitCents(variant, tierUnitCents);
      var compare = null;
      var onSaleClass = false;
      if (tierUnitCents != null && tierUnitCents < base) {
        compare = base;
        onSaleClass = true;
      } else if (ca && ca > base) {
        compare = ca;
        onSaleClass = true;
      }
      if (stickyPrice) stickyPrice.textContent = safeFormatMoney(display);
      var priceWrap = productRoot.querySelector('[data-product-price-wrap]');
      if (!priceWrap) return;
      var displayMoney = safeFormatMoney(display);
      var compareKey = compare != null ? String(compare) : '';
      var priceEl = priceWrap.querySelector('.price');
      if (priceEl) {
        var currentEl = priceEl.querySelector('.price__current');
        var compareEl = priceEl.querySelector('.price__compare');
        if (
          currentEl &&
          priceWrap.getAttribute('data-display-cents') === String(display) &&
          priceWrap.getAttribute('data-compare-cents') === compareKey
        ) {
          return;
        }
        priceEl.classList.toggle('price--on-sale', onSaleClass);
        if (currentEl) currentEl.textContent = displayMoney;
        if (compare != null) {
          if (!compareEl) {
            compareEl = document.createElement('span');
            compareEl.className = 'price__compare';
            priceEl.appendChild(compareEl);
          }
          compareEl.textContent = safeFormatMoney(compare);
        } else if (compareEl) {
          compareEl.remove();
        }
        priceWrap.setAttribute('data-display-cents', String(display));
        priceWrap.setAttribute('data-compare-cents', compareKey);
        return;
      }
      var html = '<div class="price' + (onSaleClass ? ' price--on-sale' : '') + '">';
      html += '<span class="price__current">' + displayMoney + '</span>';
      if (compare != null) {
        html += '<span class="price__compare">' + safeFormatMoney(compare) + '</span>';
      }
      html += '</div>';
      priceWrap.innerHTML = html;
      priceWrap.setAttribute('data-display-cents', String(display));
      priceWrap.setAttribute('data-compare-cents', compareKey);
    }

    function updateProductLineTotal(variant, qty, tierUnitCents) {
      var lineTotalEl = productRoot.querySelector('[data-product-line-total]');
      if (!lineTotalEl || !variant) return;
      var unitCents = getVariantDisplayUnitCents(variant, tierUnitCents);
      lineTotalEl.textContent = safeFormatMoney(unitCents * qty);
    }

    function updateQuantitySubtotal(variant, qty, tierUnitCents) {
      var subtotalEl = productRoot.querySelector('[data-product-qty-subtotal]');
      if (!subtotalEl || !variant) return;
      var unitCents = getVariantDisplayUnitCents(variant, tierUnitCents);
      subtotalEl.textContent = safeFormatMoney(unitCents * qty);
    }

    function updateProductLoyaltyEarn(variant, qty, tierUnitCents) {
      var banner = productRoot.querySelector('[data-product-loyalty-earn]');
      if (!banner || !variant) return;
      var pointsPer = parseFloat(banner.getAttribute('data-loyalty-points-per')) || 1;
      var minor = parseInt(banner.getAttribute('data-loyalty-currency-minor'), 10) || 100;
      var unitCents = getVariantDisplayUnitCents(variant, tierUnitCents);
      var lineCents = unitCents * qty;
      var points = Math.floor((lineCents / minor) * pointsPer);
      var textEl = banner.querySelector('[data-product-loyalty-text]');
      if (!textEl) return;
      var template = banner.getAttribute('data-loyalty-message') || '';
      var nextText = template.replace(/\[points\]/g, String(points));
      if (textEl.textContent !== nextText) {
        textEl.textContent = nextText;
        banner.classList.remove('is-points-updated');
        void banner.offsetWidth;
        banner.classList.add('is-points-updated');
      }
    }

    function updateProductFreeShippingBar(variant, qty, tierUnitCents) {
      var bar = productRoot.querySelector('[data-product-free-shipping]');
      if (!bar || !variant) return;

      var threshold = parseInt(bar.getAttribute('data-free-shipping-threshold'), 10) || 0;
      if (threshold <= 0) return;

      if (isNaN(qty) || qty < 1) qty = 1;
      var unitCents = getVariantDisplayUnitCents(variant, tierUnitCents);
      var projected = unitCents * qty;
      var remaining = Math.max(0, threshold - projected);
      var progress = threshold > 0 ? Math.min(100, Math.floor((projected * 100) / threshold)) : 0;
      var fill = bar.querySelector('[data-product-free-shipping-bar]');
      var textEl = bar.querySelector('[data-product-free-shipping-text]');

      if (fill) fill.style.width = progress + '%';

      if (!textEl) return;

      if (projected >= threshold) {
        textEl.textContent = bar.getAttribute('data-free-shipping-success') || 'You unlocked free shipping!';
        return;
      }

      var template = bar.getAttribute('data-free-shipping-progress') || "You're only [amount] away from free shipping!";
      textEl.textContent = template.replace(/\[amount\]/g, safeFormatMoney(remaining));
    }

    function setPriceState(variant) {
      if (!variant) return;
      refreshBulkTiersCache();
      var qtyInput = productRoot.querySelector('input[name="quantity"], input[id^="Quantity-"]');
      var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      if (isNaN(qty) || qty < 1) qty = 1;
      var tierCents = tierUnitCentsForQty(qty, bulkTiersCache);
      renderProductPrice(variant, tierCents);
      updateProductLineTotal(variant, qty, tierCents);
      updateQuantitySubtotal(variant, qty, tierCents);
      updateProductLoyaltyEarn(variant, qty, tierCents);
      updateBulkSavingsSummary(variant, qty);
      updateProductFreeShippingBar(variant, qty, tierCents);
    }

    var qtyPriceTimer = null;
    function updatePriceForQuantity(immediate) {
      if (qtyPriceTimer) {
        clearTimeout(qtyPriceTimer);
        qtyPriceTimer = null;
      }
      var run = function() {
        var variant = getCurrentVariantModel();
        if (!variant) return;
        setPriceState(variant);
      };
      if (immediate) {
        run();
        return;
      }
      qtyPriceTimer = setTimeout(run, 120);
    }

    function dispatchInputChange(input) {
      if (!input) return;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function notifyVariantChange(variant) {
      variantInputs.forEach(dispatchInputChange);
      if (!variant) return;
      try {
        document.dispatchEvent(new CustomEvent('variant:change', {
          bubbles: true,
          detail: { variant: variant }
        }));
        document.dispatchEvent(new CustomEvent('variant-change', {
          bubbles: true,
          detail: { variant: variant }
        }));
      } catch (e) {}
    }

    function updateVariantUrl(variant) {
      if (!variant || !window.history || !window.history.replaceState) return;
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', String(variant.id));
        window.history.replaceState({}, '', url.toString());
      } catch (e) {}
    }

    function anchorHasVolumeDiscountMarkup(el) {
      if (!el) return false;
      if (el.querySelector('[class*="dealeasy"], [id*="dealeasy"], [class*="lb-volume-discount"], [id*="volume-discount"], shopify-app-block, table')) {
        return true;
      }
      return (el.textContent || '').replace(/\s+/g, ' ').trim().length > 0;
    }

    function findVolumeDiscountRootForRelocate(scope) {
      if (!scope) return null;
      var selectors = [
        '[class*="dealeasy"]',
        '[id*="dealeasy"]',
        '[class*="lb-volume-discount"]',
        '[class*="lb_volume_discount"]',
        '[id*="lb-volume"]',
        '[id*="volume-discount"]',
        '[data-lb-volume-discount]',
        '[data-dealeasy]',
        '.lb-volume-discount'
      ];
      var i;
      var el;
      for (i = 0; i < selectors.length; i++) {
        el = scope.querySelector(selectors[i]);
        if (el && !el.closest('[data-volume-discount-anchor]')) {
          return el;
        }
      }
      var tables = scope.querySelectorAll('table');
      for (i = 0; i < tables.length; i++) {
        var tbl = tables[i];
        if (tbl.closest('[data-volume-discount-anchor]') || tbl.closest('.product-main__tiers')) {
          continue;
        }
        var body = (tbl.textContent || '').toLowerCase();
        if (
          body.indexOf('discounted') === -1 &&
          body.indexOf('discount') === -1 &&
          body.indexOf('dealeasy') === -1 &&
          body.indexOf('bulk') === -1
        ) {
          continue;
        }
        var wrap = tbl;
        var depth = 0;
        while (wrap && wrap !== scope && depth < 10) {
          var txt = wrap.textContent || '';
          if (txt.indexOf('Bulk discount') !== -1) {
            return wrap;
          }
          wrap = wrap.parentElement;
          depth++;
        }
        return tbl.parentElement || tbl;
      }
      return null;
    }

    function ensureVolumeDiscountAnchorVisible(anchor) {
      if (!anchor) return;
      anchor.hidden = false;
      anchor.removeAttribute('hidden');
      anchor.style.removeProperty('display');
      anchor.style.removeProperty('visibility');
      anchor.setAttribute('aria-hidden', 'false');
      anchor.querySelectorAll('[class*="dealeasy"], [id*="dealeasy"], [class*="lb-volume-discount"], shopify-app-block, table').forEach(function(node) {
        if (!node || !node.style) return;
        node.hidden = false;
        node.removeAttribute('hidden');
        node.style.removeProperty('display');
        node.style.removeProperty('visibility');
      });
    }

    function relocateVolumeDiscountWidget() {
      var anchor = productRoot.querySelector('[data-volume-discount-anchor]');
      if (!anchor) return;
      var widget = findVolumeDiscountRootForRelocate(productRoot);
      if (widget && !anchor.contains(widget)) {
        try {
          anchor.appendChild(widget);
        } catch (e) {}
      }
      ensureVolumeDiscountAnchorVisible(anchor);
    }

    var volumeDiscountRefreshTimer = null;
    function refreshVolumeDiscountWidget(variant) {
      if (!variant) return;
      var sectionId = productRoot.getAttribute('data-section-id');
      var anchor = productRoot.querySelector('[data-volume-discount-anchor]');
      if (!sectionId || !anchor) return;
      if (volumeDiscountRefreshTimer) clearTimeout(volumeDiscountRefreshTimer);
      volumeDiscountRefreshTimer = setTimeout(function() {
        var requestUrl = window.location.pathname + '?section_id=' + encodeURIComponent(sectionId) + '&variant=' + encodeURIComponent(variant.id);
        fetch(requestUrl, { credentials: 'same-origin' })
          .then(function(res) {
            if (!res.ok) throw new Error('section render failed');
            return res.text();
          })
          .then(function(html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var newAnchor = doc.querySelector('[data-volume-discount-anchor]');
            if (newAnchor && anchorHasVolumeDiscountMarkup(newAnchor)) {
              anchor.innerHTML = newAnchor.innerHTML;
            }
            relocateVolumeDiscountWidget();
            [300, 1200].forEach(function(ms) {
              setTimeout(relocateVolumeDiscountWidget, ms);
            });
            try {
              window.dispatchEvent(new CustomEvent('mogi:volume-discount-ready'));
            } catch (e2) {}
            updatePriceForQuantity();
          })
          .catch(function() {
            relocateVolumeDiscountWidget();
          });
      }, 80);
    }

    function isMobileViewport() {
      return window.matchMedia('(max-width: 749px)').matches;
    }

    function isOptionPickerActive(group) {
      if (!group) return false;
      var mode = group.getAttribute('data-responsive-option-picker');
      if (!mode) return true;
      var mobile = isMobileViewport();
      if (mode === 'mobile') return mobile;
      if (mode === 'desktop') return !mobile;
      return true;
    }

    function getSelectedOptionsByIndex() {
      var selected = [];
      var groups = productRoot.querySelectorAll('.product-main__option-picker');
      Array.prototype.forEach.call(groups, function(group) {
        if (!isOptionPickerActive(group)) return;
        var optionIndex = parseInt(group.getAttribute('data-option-index'), 10);
        if (isNaN(optionIndex)) return;
        var select = group.querySelector('select[data-variant-option-input]');
        var checked = group.querySelector('input[data-variant-option-input]:checked');
        selected[optionIndex] = select ? select.value : (checked ? checked.value : null);
      });
      return selected;
    }

    function syncResponsiveOptionPickers() {
      var groups = productRoot.querySelectorAll('[data-responsive-option-picker]');
      if (!groups.length) return;
      var mobile = isMobileViewport();
      var valuesByIndex = {};

      Array.prototype.forEach.call(groups, function(group) {
        var optionIndex = group.getAttribute('data-option-index');
        var select = group.querySelector('select[data-variant-option-input]');
        var checked = group.querySelector('input[data-variant-option-input]:checked');
        var value = select ? select.value : (checked ? checked.value : null);
        if (value && valuesByIndex[optionIndex] == null) {
          valuesByIndex[optionIndex] = value;
        }
      });

      Array.prototype.forEach.call(groups, function(group) {
        var mode = group.getAttribute('data-responsive-option-picker');
        var active = mode === 'mobile' ? mobile : !mobile;
        var optionIndex = group.getAttribute('data-option-index');
        var value = valuesByIndex[optionIndex];
        var inputs = group.querySelectorAll('[data-variant-option-input]');

        Array.prototype.forEach.call(inputs, function(input) {
          if (input.tagName === 'SELECT') {
            input.disabled = !active;
            if (active && value) input.value = value;
          } else {
            var soldOut = input.closest('.product-main__variant-pill') &&
              input.closest('.product-main__variant-pill').classList.contains('is-unavailable');
            input.disabled = !active || soldOut;
            if (active && value && input.value === value) {
              input.checked = true;
            }
          }
        });
      });
    }

    function isOptionValueAvailable(optionIndex, value, selectedOptions) {
      if (!variants.length || value == null) return false;
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (!v.available || v.options[optionIndex] !== value) continue;
        var matches = true;
        for (var j = 0; j < selectedOptions.length; j++) {
          if (j === optionIndex) continue;
          if (selectedOptions[j] && v.options[j] !== selectedOptions[j]) {
            matches = false;
            break;
          }
        }
        if (matches) return true;
      }
      return false;
    }

    function ensureValidOptionSelections() {
      var groups = productRoot.querySelectorAll('.product-main__option-picker');
      var selectedOptions = getSelectedOptionsByIndex();
      var changed = false;

      Array.prototype.forEach.call(groups, function(group) {
        if (!isOptionPickerActive(group)) return;
        var optionIndex = parseInt(group.getAttribute('data-option-index'), 10);
        if (isNaN(optionIndex)) return;
        var currentValue = selectedOptions[optionIndex];
        if (!currentValue || isOptionValueAvailable(optionIndex, currentValue, selectedOptions)) return;

        var select = group.querySelector('select[data-variant-option-input]');
        if (select) {
          var options = select.options;
          for (var o = 0; o < options.length; o++) {
            var optionEl = options[o];
            if (!optionEl.value) continue;
            if (isOptionValueAvailable(optionIndex, optionEl.value, selectedOptions)) {
              select.value = optionEl.value;
              selectedOptions[optionIndex] = optionEl.value;
              changed = true;
              break;
            }
          }
          return;
        }

        var radios = group.querySelectorAll('input[type="radio"][data-variant-option-input]');
        Array.prototype.forEach.call(radios, function(radio) {
          if (changed) return;
          if (isOptionValueAvailable(optionIndex, radio.value, selectedOptions)) {
            radio.checked = true;
            selectedOptions[optionIndex] = radio.value;
            changed = true;
          }
        });
      });

      return changed;
    }

    function updateOptionAvailability() {
      if (!variants.length) return;
      syncResponsiveOptionPickers();
      ensureValidOptionSelections();
      var selectedOptions = getSelectedOptionsByIndex();
      var groups = productRoot.querySelectorAll('.product-main__option-picker');

      Array.prototype.forEach.call(groups, function(group) {
        var optionIndex = parseInt(group.getAttribute('data-option-index'), 10);
        if (isNaN(optionIndex)) return;
        var pickerActive = isOptionPickerActive(group);
        var select = group.querySelector('select[data-variant-option-input]');
        if (select) {
          Array.prototype.forEach.call(select.options, function(optionEl) {
            if (!optionEl.value) return;
            var available = isOptionValueAvailable(optionIndex, optionEl.value, selectedOptions);
            optionEl.disabled = !available;
            var label = optionEl.textContent || '';
            label = label.replace(/\s*[–-]\s*Sold out\s*$/i, '').trim();
            optionEl.textContent = available ? label : label + ' – Sold out';
          });
          select.disabled = !pickerActive;
          return;
        }

        var radios = group.querySelectorAll('input[type="radio"][data-variant-option-input]');
        Array.prototype.forEach.call(radios, function(radio) {
          var available = isOptionValueAvailable(optionIndex, radio.value, selectedOptions);
          radio.disabled = !pickerActive || !available;
          var pill = radio.closest('.product-main__variant-pill');
          if (pill) {
            pill.classList.toggle('is-unavailable', !available);
            pill.setAttribute('aria-disabled', available ? 'false' : 'true');
            var baseTitle = radio.getAttribute('data-color-value') || radio.value || '';
            pill.setAttribute('title', available ? baseTitle : baseTitle + ' — Sold out');
          }
        });
      });

      updateSelectedColorLabel();
    }

    function updateSelectedColorLabel() {
      var pickers = productRoot.querySelectorAll('.product-main__option-picker--color, .product-main__option-picker--image');
      Array.prototype.forEach.call(pickers, function(picker) {
        if (!isOptionPickerActive(picker)) return;
        var labelEl = picker.querySelector('[data-option-selected]');
        if (!labelEl) return;
        var checked = picker.querySelector('input[data-variant-option-input]:checked');
        if (checked) {
          labelEl.textContent = checked.getAttribute('data-color-value') || checked.value || '';
        }
      });
    }

    function applyVariantState(variant) {
      if (!variant) return;
      variantInputs.forEach(function(input) {
        input.value = variant.id;
      });
      if (variantInput) variantInput.value = variant.id;
      if (variantSelect) variantSelect.value = String(variant.id);
      if (skuEl) skuEl.textContent = variant.sku || '';
      if (addToCartBtn) addToCartBtn.disabled = !variant.available;
      if (stickySubmit) stickySubmit.disabled = !variant.available;
      setInventoryState(variant);
      setPriceState(variant);
      setMediaForVariant(variant);
      updateVariantUrl(variant);
      updateSelectedColorLabel();
      notifyVariantChange(variant);
      relocateVolumeDiscountWidget();
      refreshVolumeDiscountWidget(variant);
    }

    if (variantSelect) {
      variantSelect.addEventListener('change', function() {
        var variant = findVariantById(variantSelect.value);
        applyVariantState(variant);
      });
    }

    if (optionInputs.length) {
      updateOptionAvailability();
      optionInputs.forEach(function(input) {
        input.addEventListener('change', function() {
          updateOptionAvailability();
          var variant = findVariantFromOptions();
          applyVariantState(variant);
        });
      });
      var initialVariant = findVariantFromOptions();
      if (initialVariant) applyVariantState(initialVariant);

      var mobileMq = window.matchMedia('(max-width: 749px)');
      var onViewportChange = function() {
        syncResponsiveOptionPickers();
        updateOptionAvailability();
        var variant = findVariantFromOptions();
        if (variant) applyVariantState(variant);
      };
      if (mobileMq.addEventListener) {
        mobileMq.addEventListener('change', onViewportChange);
      } else if (mobileMq.addListener) {
        mobileMq.addListener(onViewportChange);
      }
    }

    if (stickySubmit && form) {
      stickySubmit.addEventListener('click', function() {
        if (addToCartBtn && !addToCartBtn.disabled) {
          addToCartBtn.focus();
          addToCartBtn.click();
        }
      });
    }

    var qtyField = productRoot.querySelector('input[name="quantity"], input[id^="Quantity-"]');
    if (qtyField) {
      qtyField.addEventListener('input', function() {
        updatePriceForQuantity(false);
      });
      qtyField.addEventListener('change', function() {
        updatePriceForQuantity(true);
      });
    }

    [0, 400, 1200, 2500].forEach(function(ms) {
      setTimeout(function() {
        updatePriceForQuantity();
      }, ms);
    });

    document.addEventListener('mogi:volume-discount-ready', function() {
      updatePriceForQuantity();
    });

    updatePriceForQuantity();

    if (isDesignMode) {
      document.addEventListener('shopify:section:load', function(event) {
        if (!event || !event.target || !event.target.querySelector) return;
        var loadedRoot = event.target.querySelector('[data-product-root]');
        if (!loadedRoot || loadedRoot !== productRoot) return;
        updatePriceForQuantity();
      });
    }
  })();

  // Product card hover videos (archive/grid)
  (function() {
    var cards = document.querySelectorAll('.product-card');
    if (!cards.length) return;

    cards.forEach(function(card) {
      var video = card.querySelector('.product-card__video');
      if (!video) return;

      card.addEventListener('mouseenter', function() {
        try {
          video.play();
        } catch (e) {}
      });

      card.addEventListener('mouseleave', function() {
        try {
          video.pause();
          video.currentTime = 0;
        } catch (e) {}
      });
    });
  })();

  // Search popup + suggestions
  (function() {
    var wrapper = document.querySelector('[data-search-wrapper]');
    if (!wrapper) return;
    var input = wrapper.querySelector('[data-search-input]');
    var suggestions = wrapper.querySelector('[data-search-suggestions]');
    var form = wrapper.querySelector('[data-search-form]');
    var productsWrap = wrapper.querySelector('[data-search-products]');
    var searchToggle = document.querySelector('[data-search-toggle]');
    var searchPopup = document.querySelector('[data-search-popup]');
    var searchCloseTriggers = searchPopup ? searchPopup.querySelectorAll('[data-search-close]') : [];
    if (!input || !suggestions) return;
    var searchTimer = null;

    function updateBodyScrollLock() {
      var popupOpen = searchPopup && searchPopup.classList.contains('is-open');
      var menuOpen = navMenu && navMenu.classList.contains('active');
      document.body.style.overflow = popupOpen || menuOpen ? 'hidden' : '';
      document.body.classList.toggle('search-popup-open', !!popupOpen);
    }

    function setSearchPopupOpen(open) {
      if (!searchPopup || !searchToggle) return;
      if (open && navMenu && navMenu.classList.contains('active')) {
        setMobileNavOpen(false);
      }
      searchPopup.classList.toggle('is-open', open);
      searchToggle.classList.toggle('is-active', open);
      searchToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      searchToggle.setAttribute('aria-label', open ? 'Close search' : 'Open search');
      searchPopup.setAttribute('aria-hidden', open ? 'false' : 'true');
      updateHeaderBottom();
      updateBodyScrollLock();
      if (open) {
        if (!isDesignMode) {
          window.requestAnimationFrame(function() {
            input.focus();
          });
        }
        openSuggestions();
        fetchProducts(input.value.trim());
      } else {
        closeSuggestions();
      }
    }

    if (searchToggle && searchPopup) {
      searchToggle.addEventListener('click', function(e) {
        e.stopPropagation();
        setSearchPopupOpen(!searchPopup.classList.contains('is-open'));
      });
      searchCloseTriggers.forEach(function(el) {
        el.addEventListener('click', function() {
          setSearchPopupOpen(false);
        });
      });
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && searchPopup.classList.contains('is-open')) {
          setSearchPopupOpen(false);
          searchToggle.focus();
        }
      });
      window.addEventListener('resize', function() {
        updateHeaderBottom();
        if (window.innerWidth <= 1024 && searchPopup.classList.contains('is-open')) {
          setSearchPopupOpen(false);
        }
      });
    }

    function positionSuggestions() {
      if (!suggestions) return;
      suggestions.classList.remove('search-suggestions--align-right');
      suggestions.style.left = '';
      suggestions.style.right = '';
      var rect = suggestions.getBoundingClientRect();
      var viewportPadding = 10;
      if (rect.right > (window.innerWidth - viewportPadding)) {
        suggestions.classList.add('search-suggestions--align-right');
        suggestions.style.left = 'auto';
        suggestions.style.right = '0';
      } else if (rect.left < viewportPadding) {
        suggestions.style.left = '0';
        suggestions.style.right = 'auto';
      }
      alignSearchSuggestionsArrow();
    }

    function alignSearchSuggestionsArrow() {
      var bar = wrapper.querySelector('.search-bar');
      var arrow = suggestions.querySelector('.search-suggestions__arrow');
      if (!bar || !arrow) return;
      var barRect = bar.getBoundingClientRect();
      var suggRect = suggestions.getBoundingClientRect();
      if (!suggRect.width) return;
      var centerX = barRect.left + barRect.width / 2 - suggRect.left;
      arrow.style.left = Math.max(12, Math.min(centerX, suggRect.width - 12)) + 'px';
      arrow.style.right = 'auto';
    }

    function openSuggestions() {
      suggestions.classList.add('is-visible');
      positionSuggestions();
      requestAnimationFrame(function() {
        alignSearchSuggestionsArrow();
        requestAnimationFrame(alignSearchSuggestionsArrow);
      });
    }

    function closeSuggestions() {
      suggestions.classList.remove('is-visible');
    }

    function renderProducts(products, term) {
      if (!productsWrap) return;
      if (!products || !products.length) {
        productsWrap.innerHTML = term
          ? '<div class="search-suggestions__empty">No matching products found.</div>'
          : '<div class="search-suggestions__empty">Start typing to see matching products.</div>';
        return;
      }
      var html = '';
      products.forEach(function(product) {
        html += '<a class="search-suggestions__product" href="' + product.url + '">';
        if (product.image) {
          html += '<img src="' + product.image + '" alt="">';
        } else {
          html += '<span></span>';
        }
        html += '<span class="search-suggestions__product-title">' + escapeHtml(product.title || '') + '</span>';
        html += '</a>';
      });
      productsWrap.innerHTML = html;
    }

    function fetchProducts(term) {
      if (!productsWrap) return;
      if (!term) {
        renderProducts([], '');
        return;
      }
      productsWrap.classList.add('is-loading');
      fetch('/search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=product&resources[limit]=4')
        .then(function(res) { return res.json(); })
        .then(function(data) {
          var products = data && data.resources && data.resources.results && data.resources.results.products
            ? data.resources.results.products
            : [];
          renderProducts(products, term);
          productsWrap.classList.remove('is-loading');
        })
        .catch(function() {
          renderProducts([], term);
          productsWrap.classList.remove('is-loading');
        });
    }

    input.addEventListener('focus', function() {
      openSuggestions();
      fetchProducts(input.value.trim());
    });

    input.addEventListener('input', function() {
      openSuggestions();
      clearTimeout(searchTimer);
      var term = input.value.trim();
      searchTimer = setTimeout(function() {
        fetchProducts(term);
      }, 180);
    });

    document.addEventListener('click', function(e) {
      var insideSearch =
        wrapper.contains(e.target) ||
        (searchToggle && searchToggle.contains(e.target)) ||
        (searchPopup && searchPopup.contains(e.target));
      if (!insideSearch) {
        if (searchPopup && searchPopup.classList.contains('is-open')) {
          setSearchPopupOpen(false);
        } else {
          closeSuggestions();
        }
      }
    });

    window.addEventListener('resize', function() {
      if (suggestions.classList.contains('is-visible')) {
        positionSuggestions();
        alignSearchSuggestionsArrow();
      }
    });

    suggestions.addEventListener('click', function(e) {
      var chip = e.target.closest('.search-chip');
      if (!chip) return;
      var term = chip.getAttribute('data-search-term') || chip.textContent;
      input.value = term;
      fetchProducts(term);
      if (form) form.submit();
    });
  })();

  // Tier pricing quantity highlight on product page
  (function() {
    var qtyInput = document.querySelector('.product-main__quantity input[name="quantity"]');
    var tierCells = Array.prototype.slice.call(document.querySelectorAll('[data-tier-pricing] [data-tier-min]'));
    if (!qtyInput || !tierCells.length) return;

    function updateActiveTier() {
      var qty = parseInt(qtyInput.value, 10) || 1;
      var activeMin = -1;
      tierCells.forEach(function(cell) {
        var minQty = parseInt(cell.getAttribute('data-tier-min'), 10) || 0;
        if (qty >= minQty && minQty > activeMin) activeMin = minQty;
      });
      tierCells.forEach(function(cell) {
        var minQty = parseInt(cell.getAttribute('data-tier-min'), 10) || 0;
        cell.classList.toggle('is-active', minQty === activeMin);
      });
    }

    qtyInput.addEventListener('input', updateActiveTier);
    updateActiveTier();
  })();

  // Product details tabs (Description / Shipping / Care)
  (function() {
    var tabRoots = document.querySelectorAll('[data-product-details-tabs]');
    if (!tabRoots.length) return;

    tabRoots.forEach(function(root) {
      var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-details-tab-target]'));
      var panels = Array.prototype.slice.call(root.querySelectorAll('[data-details-tab-panel]'));
      if (!tabs.length || !panels.length) return;

      function activate(target) {
        tabs.forEach(function(tab) {
          var isActive = tab.getAttribute('data-details-tab-target') === target;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
        panels.forEach(function(panel) {
          var isActive = panel.getAttribute('data-details-tab-panel') === target;
          panel.classList.toggle('is-active', isActive);
        });
      }

      tabs.forEach(function(tab) {
        tab.addEventListener('click', function() {
          activate(tab.getAttribute('data-details-tab-target'));
        });
      });
    });
  })();

  // Floating hero simple slider (if enabled)
  (function() {
    var tracks = document.querySelectorAll('[data-floating-hero-track]');
    if (!tracks.length) return;

    tracks.forEach(function(track) {
      var sliderStyle = track.getAttribute('data-slider-style') || 'single';
      if (sliderStyle === 'gallery_loop') return;

      var slides = track.querySelectorAll('.floating-hero-slide');
      if (!slides.length) return;

      var sliderRoot = track.closest('.floating-hero-slider');
      var prev = sliderRoot ? sliderRoot.querySelector('.floating-hero-slider__arrow--prev') : null;
      var next = sliderRoot ? sliderRoot.querySelector('.floating-hero-slider__arrow--next') : null;
      var index = 0;
      var autoSlide = track.getAttribute('data-single-autoplay') === 'true';
      var autoSlideSeconds = parseInt(track.getAttribute('data-single-autoplay-seconds'), 10) || 4;
      var autoSlideTimer = null;

      function showSlide(i) {
        index = (i + slides.length) % slides.length;
        slides.forEach(function(slide, idx) {
          slide.style.display = idx === index ? 'block' : 'none';
        });
      }

      showSlide(0);

      if (prev && next) {
        prev.addEventListener('click', function() { showSlide(index - 1); });
        next.addEventListener('click', function() { showSlide(index + 1); });
      }

      if (autoSlide && slides.length > 1) {
        autoSlideTimer = setInterval(function() {
          showSlide(index + 1);
        }, Math.max(2, autoSlideSeconds) * 1000);

        track.addEventListener('mouseenter', function() {
          if (autoSlideTimer) {
            clearInterval(autoSlideTimer);
            autoSlideTimer = null;
          }
        });

        track.addEventListener('mouseleave', function() {
          if (!autoSlideTimer) {
            autoSlideTimer = setInterval(function() {
              showSlide(index + 1);
            }, Math.max(2, autoSlideSeconds) * 1000);
          }
        });
      }
    });
  })();

  // Product carousels (new arrivals / best sellers)
  (function() {
    function loadBestSellersIntoTrack(track) {
      var handle = track.getAttribute('data-collection-handle');
      var sectionId = track.getAttribute('data-source-section-id') || 'best-sellers-collection-source';
      var limit = parseInt(track.getAttribute('data-products-limit'), 10) || 0;
      var sortBy = track.getAttribute('data-sort-by') || '';
      if (!handle) return Promise.resolve();

      var url = '/collections/' + encodeURIComponent(handle) + '?sections=' + encodeURIComponent(sectionId);
      if (sortBy) {
        url += '&sort_by=' + encodeURIComponent(sortBy);
      }

      return fetch(url)
        .then(function(response) {
          if (!response.ok) {
            throw new Error('Could not load best sellers');
          }
          return response.json();
        })
        .then(function(payload) {
          var html = payload && payload[sectionId];
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var source = doc.querySelector('[data-best-sellers-source]');
          if (!source) return;
          var cards = Array.prototype.slice.call(source.querySelectorAll('.product-card'));
          if (limit > 0 && cards.length > limit) {
            cards = cards.slice(0, limit);
          }
          track.innerHTML = '';
          cards.forEach(function(card) {
            track.appendChild(card);
          });
        })
        .catch(function() {});
    }

    var carousels = document.querySelectorAll('[data-product-carousel]');
    if (!carousels.length) return;

    carousels.forEach(function(carousel) {
      var track = carousel.querySelector('[data-product-carousel-track]');
      var prev = carousel.querySelector('.featured-collection__arrow--prev');
      var next = carousel.querySelector('.featured-collection__arrow--next');
      if (!track || !prev || !next) return;

      function initCarouselTrack() {
        if (track.getAttribute('data-randomize-products') === 'true') {
          var cardsToShuffle = Array.prototype.slice.call(track.querySelectorAll('.product-card'));
          var randomMode = track.getAttribute('data-randomize-mode') || 'per_load';
          var randomFn = Math.random;

          if (randomMode === 'daily') {
            var today = new Date();
            var seedString = [
              today.getUTCFullYear(),
              today.getUTCMonth() + 1,
              today.getUTCDate(),
              cardsToShuffle.length
            ].join('-');
            var seed = 0;
            for (var s = 0; s < seedString.length; s++) {
              seed = (seed * 31 + seedString.charCodeAt(s)) % 2147483647;
            }
            if (seed <= 0) seed = 1;
            randomFn = function() {
              seed = (seed * 48271) % 2147483647;
              return seed / 2147483647;
            };
          }

          for (var i = cardsToShuffle.length - 1; i > 0; i--) {
            var j = Math.floor(randomFn() * (i + 1));
            var temp = cardsToShuffle[i];
            cardsToShuffle[i] = cardsToShuffle[j];
            cardsToShuffle[j] = temp;
          }
          cardsToShuffle.forEach(function(card) {
            track.appendChild(card);
          });

          if (track.getAttribute('data-randomize-auto') === 'true') {
            var finalLimit = parseInt(track.getAttribute('data-randomize-limit'), 10) || 0;
            if (finalLimit > 0 && cardsToShuffle.length > finalLimit) {
              for (var k = finalLimit; k < cardsToShuffle.length; k++) {
                cardsToShuffle[k].remove();
              }
            }
          }
        }

        function isMobileShowcaseLayout() {
          var layout = track.getAttribute('data-mobile-layout') || 'carousel';
          var carousel = track.closest('.featured-collection__carousel');
          if (carousel && carousel.classList.contains('featured-collection__carousel--mobile-showcase')) {
            layout = 'showcase';
          }
          return layout === 'showcase' && window.innerWidth <= 900;
        }

        function getStep() {
          if (isMobileShowcaseLayout()) return 0;
          var card = track.querySelector('.product-card');
          if (!card) return 240;
          var gap = 18;
          try {
            var gapValue = window.getComputedStyle(track).columnGap || window.getComputedStyle(track).gap;
            gap = parseFloat(gapValue) || 18;
          } catch (e) {}
          var isMobileTwoUp =
            window.innerWidth <= 900 &&
            track.classList.contains('featured-collection__grid--mobile-2');
          if (isMobileTwoUp) {
            return track.clientWidth + gap;
          }
          var cardWidth = card.offsetWidth || 240;
          return cardWidth + gap;
        }

        function scrollByStep(direction) {
          if (isMobileShowcaseLayout()) return;
          var maxScroll = track.scrollWidth - track.clientWidth;
          var nextScroll = track.scrollLeft + direction * getStep();
          if (nextScroll < 0) nextScroll = 0;
          if (nextScroll > maxScroll) nextScroll = maxScroll;
          track.scrollTo({ left: nextScroll, behavior: 'smooth' });
        }

        if (!isMobileShowcaseLayout()) {
          prev.addEventListener('click', function() { scrollByStep(-1); });
          next.addEventListener('click', function() { scrollByStep(1); });
        }
      }

      if (track.getAttribute('data-best-sellers-fetch') === 'true') {
        loadBestSellersIntoTrack(track).then(initCarouselTrack);
      } else {
        initCarouselTrack();
      }
    });
  })();

  (function() {
    function loadBestSellersIntoTrack(track) {
      var handle = track.getAttribute('data-collection-handle');
      var sectionId = track.getAttribute('data-source-section-id') || 'best-sellers-collection-source';
      var limit = parseInt(track.getAttribute('data-products-limit'), 10) || 0;
      var sortBy = track.getAttribute('data-sort-by') || '';
      if (!handle) return Promise.resolve();

      var url = '/collections/' + encodeURIComponent(handle) + '?sections=' + encodeURIComponent(sectionId);
      if (sortBy) {
        url += '&sort_by=' + encodeURIComponent(sortBy);
      }

      return fetch(url)
        .then(function(response) {
          if (!response.ok) {
            throw new Error('Could not load best sellers');
          }
          return response.json();
        })
        .then(function(payload) {
          var html = payload && payload[sectionId];
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var source = doc.querySelector('[data-best-sellers-source]');
          if (!source) return;
          var cards = Array.prototype.slice.call(source.querySelectorAll('.product-card'));
          if (limit > 0 && cards.length > limit) {
            cards = cards.slice(0, limit);
          }
          track.innerHTML = '';
          cards.forEach(function(card) {
            track.appendChild(card);
          });
        })
        .catch(function() {});
    }

    document.querySelectorAll('[data-best-sellers-fetch]').forEach(function(track) {
      if (track.closest('[data-product-carousel]')) return;
      loadBestSellersIntoTrack(track);
    });
  })();

  // Collection filters and sorting with AJAX updates
  (function() {
    var collectionRoot = document.querySelector('.collection-main');
    if (!collectionRoot) return;

    var submitTimer = null;
    var isUpdating = false;

    function parseHTML(html) {
      var parser = new DOMParser();
      return parser.parseFromString(html, 'text/html');
    }

    function setLoadingState(active) {
      if (!collectionRoot) return;
      collectionRoot.classList.toggle('is-updating', !!active);
      collectionRoot.setAttribute('aria-busy', active ? 'true' : 'false');
    }

    function readFiltersUrlFromForm(form) {
      var action = form.getAttribute('action') || window.location.pathname;
      var url = new URL(action, window.location.origin);
      var formData = new FormData(form);
      var params = new URLSearchParams();
      formData.forEach(function(value, key) {
        if (value === null || value === undefined || value === '') return;
        params.append(key, value);
      });
      url.search = params.toString();
      return url;
    }

    function replaceCollectionFromHTML(html, pushHistory, nextUrl) {
      var doc = parseHTML(html);
      var nextRoot = doc.querySelector('.collection-main');
      if (!nextRoot || !collectionRoot || !collectionRoot.parentNode) {
        window.location.href = nextUrl || window.location.href;
        return;
      }

      collectionRoot.parentNode.replaceChild(nextRoot, collectionRoot);
      collectionRoot = nextRoot;
      setLoadingState(false);
      isUpdating = false;
      window.scrollTo({ top: 0, behavior: 'smooth' });

      if (pushHistory && nextUrl) {
        window.history.pushState({ collectionAjax: true }, '', nextUrl);
      }
    }

    function fetchAndSwap(nextUrl, pushHistory) {
      if (!nextUrl || isUpdating) return;
      isUpdating = true;
      setLoadingState(true);

      fetch(nextUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function(res) { return res.text(); })
        .then(function(html) {
          replaceCollectionFromHTML(html, pushHistory, nextUrl);
        })
        .catch(function() {
          window.location.href = nextUrl;
        })
        .finally(function() {
          setLoadingState(false);
          isUpdating = false;
        });
    }

    document.addEventListener('submit', function(e) {
      var form = e.target;
      if (!form || !form.matches || !form.matches('[data-collection-filters]')) return;
      e.preventDefault();
      var nextUrl = readFiltersUrlFromForm(form).toString();
      fetchAndSwap(nextUrl, true);
    });

    document.addEventListener('change', function(e) {
      var form = e.target && e.target.closest ? e.target.closest('[data-collection-filters]') : null;
      if (!form) return;
      var mode = form.getAttribute('data-filter-apply-mode') || 'manual';
      if (mode !== 'auto') return;

      var target = e.target;
      if (!target) return;
      if (target.name === 'sort_by' || target.type === 'checkbox' || target.type === 'radio' || target.type === 'select-one' || target.type === 'number') {
        clearTimeout(submitTimer);
        submitTimer = setTimeout(function() {
          var nextUrl = readFiltersUrlFromForm(form).toString();
          fetchAndSwap(nextUrl, true);
        }, 120);
      }
    });

    document.addEventListener('click', function(e) {
      var link = e.target.closest && e.target.closest('.collection-main__active-filters a, .collection-main__active-filter, .collection-main__clear-filters');
      if (!link) return;
      var href = link.getAttribute('href');
      if (!href) return;
      e.preventDefault();
      fetchAndSwap(new URL(href, window.location.origin).toString(), true);
    });

    window.addEventListener('popstate', function() {
      if (!document.querySelector('.collection-main')) return;
      fetchAndSwap(window.location.href, false);
    });
  })();

  // Recently viewed products: track on product pages + render on collection pages
  (function() {
    var STORAGE_KEY = 'mogi_recently_viewed_products';
    var MAX_STORED = 20;

    function getStoredHandles() {
      try {
        var raw = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
        if (!Array.isArray(raw)) return [];
        return raw.filter(function(v) { return typeof v === 'string' && v.length; });
      } catch (e) {
        return [];
      }
    }

    function saveHandle(handle) {
      if (!handle) return;
      var handles = getStoredHandles().filter(function(h) { return h !== handle; });
      handles.unshift(handle);
      if (handles.length > MAX_STORED) handles = handles.slice(0, MAX_STORED);
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify(handles)); } catch (e) {}
    }

    var productPathMatch = (window.location.pathname || '').match(/^\/products\/([^\/?#]+)/i);
    if (productPathMatch && productPathMatch[1]) {
      saveHandle(decodeURIComponent(productPathMatch[1]));
    }

    var wrappers = document.querySelectorAll('[data-recently-viewed]');
    if (!wrappers.length) return;

    function fetchProduct(handle) {
      return fetch('/products/' + encodeURIComponent(handle) + '.js', {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function(res) {
          if (!res.ok) throw new Error('Not found');
          return res.json();
        })
        .catch(function() { return null; });
    }

    wrappers.forEach(function(wrapper) {
      var grid = wrapper.querySelector('[data-recently-viewed-grid]');
      if (!grid) return;
      var limit = parseInt(wrapper.getAttribute('data-limit'), 10) || 6;
      var handles = getStoredHandles().slice(0, limit);
      if (!handles.length) return;

      Promise.all(handles.map(fetchProduct)).then(function(products) {
        var valid = products.filter(function(p) { return p && p.handle && p.title; }).slice(0, limit);
        if (!valid.length) return;

        var html = '';
        valid.forEach(function(p) {
          var image = p.featured_image || '';
          var price = safeFormatMoney(typeof p.price === 'number' ? p.price : 0);
          html += '<a class="collection-main__recently-viewed-item" href="/products/' + encodeURIComponent(p.handle) + '">';
          if (image) {
            html += '<img src="' + image + '" alt="' + escapeHtml(p.title) + '" loading="lazy">';
          }
          html += '<div class="collection-main__recently-viewed-item-body">';
          html += '<div class="collection-main__recently-viewed-item-title">' + escapeHtml(p.title) + '</div>';
          html += '<div class="collection-main__recently-viewed-item-price">' + price + '</div>';
          html += '</div></a>';
        });

        grid.innerHTML = html;
        wrapper.hidden = false;
      });
    });
  })();

  // OS 2.0 main-collection: Grid / List / Masonry (buttons existed but never toggled layout classes)
  (function() {
    var toolbar = document.querySelector('[data-collection-controls]');
    var productGrid = document.querySelector('[data-product-grid]');
    if (!toolbar || !productGrid) return;

    var storageKey = 'mogi-collection-view-mode';
    var layoutModes = ['grid', 'list', 'masonry'];

    function applyViewMode(mode) {
      if (layoutModes.indexOf(mode) === -1) mode = 'grid';
      layoutModes.forEach(function(m) {
        productGrid.classList.remove('mogi-collection__products--' + m);
      });
      productGrid.classList.add('mogi-collection__products--' + mode);

      if (mode === 'masonry') {
        productGrid.classList.remove('mogi-grid');
      } else {
        productGrid.classList.add('mogi-grid');
      }

      try {
        sessionStorage.setItem(storageKey, mode);
      } catch (err) {}

      var buttons = toolbar.querySelectorAll('[data-view-mode]');
      for (var i = 0; i < buttons.length; i++) {
        var btn = buttons[i];
        var active = btn.getAttribute('data-view-mode') === mode;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      }
    }

    var initial = 'grid';
    try {
      var stored = sessionStorage.getItem(storageKey);
      if (stored && layoutModes.indexOf(stored) !== -1) initial = stored;
    } catch (err2) {}
    applyViewMode(initial);

    toolbar.addEventListener('click', function(e) {
      var btn = e.target && e.target.closest && e.target.closest('[data-view-mode]');
      if (!btn || !toolbar.contains(btn)) return;
      e.preventDefault();
      applyViewMode(btn.getAttribute('data-view-mode') || 'grid');
    });
  })();

  // AJAX load more pagination for collection/search grids
  (function() {
    function parseHTML(html) {
      var parser = new DOMParser();
      return parser.parseFromString(html, 'text/html');
    }

    document.addEventListener('click', function(e) {
      var btn = e.target.closest && e.target.closest('[data-load-more]');
      if (!btn) return;
      e.preventDefault();

      var pagination = btn.closest('[data-pagination]');
      if (!pagination) return;

      var nextUrl = btn.getAttribute('href');
      var targetSelector = pagination.getAttribute('data-target-grid');
      if (!nextUrl || !targetSelector) return;

      var currentGrid = document.querySelector(targetSelector);
      if (!currentGrid) return;

      if (btn.classList.contains('is-loading')) return;
      btn.classList.add('is-loading');
      btn.setAttribute('aria-disabled', 'true');
      var textEl = btn.querySelector('.pagination__load-more-text');
      var originalText = textEl ? textEl.textContent : btn.textContent;
      if (textEl) {
        textEl.textContent = 'Loading...';
      } else {
        btn.textContent = 'Loading...';
      }

      fetch(nextUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function(res) { return res.text(); })
        .then(function(html) {
          var doc = parseHTML(html);
          var nextGrid = doc.querySelector(targetSelector);
          var nextPagination = doc.querySelector('[data-pagination]');
          if (!nextGrid || !nextPagination) return;

          Array.prototype.forEach.call(nextGrid.children, function(node) {
            currentGrid.appendChild(node);
          });

          pagination.outerHTML = nextPagination.outerHTML;
        })
        .catch(function() {
          window.location.href = nextUrl;
        })
        .finally(function() {
          btn.classList.remove('is-loading');
          btn.removeAttribute('aria-disabled');
          if (textEl) {
            textEl.textContent = originalText;
          } else {
            btn.textContent = originalText;
          }
        });
    });
  })();

  // Advanced wishlist (local first, AJAX actions, configurable UX)
  var wishlistRoot = document.body || document.documentElement;
  var wishlistEnabled = wishlistRoot && wishlistRoot.getAttribute('data-wishlist-enabled') === 'true';
  var wishlistLoggedInOnly = wishlistRoot && wishlistRoot.getAttribute('data-wishlist-logged-in-only') === 'true';
  var customerLoggedIn = wishlistRoot && wishlistRoot.getAttribute('data-customer-logged-in') === 'true';
  var allowGuestWishlist = wishlistRoot && wishlistRoot.getAttribute('data-wishlist-allow-guest') !== 'false';
  var wishlistLimit = parseInt((wishlistRoot && wishlistRoot.getAttribute('data-wishlist-limit')) || '100', 10);
  var wishlistToastEnabled = wishlistRoot && wishlistRoot.getAttribute('data-wishlist-toast') !== 'false';
  var wishlistLoadingEnabled = wishlistRoot && wishlistRoot.getAttribute('data-wishlist-loading') !== 'false';
  var wishlistRecentBadgeEnabled = wishlistRoot && wishlistRoot.getAttribute('data-wishlist-recent-badge') === 'true';
  var wishlistAutoSave = wishlistRoot && wishlistRoot.getAttribute('data-wishlist-auto-save') !== 'false';

  function getWishlistStorageKey() {
    return 'mogi_wishlist';
  }

  function parseWishlist(raw) {
    if (!raw) return [];
    try {
      var parsed = JSON.parse(raw);
      if (!Array.isArray(parsed)) return [];
      return parsed.filter(function(item) {
        return item && typeof item.handle === 'string' && item.handle.length > 0;
      });
    } catch (e) {
      return [];
    }
  }

  function getWishlist() {
    var rows = parseWishlist(localStorage.getItem(getWishlistStorageKey()));
    return rows.slice(0, wishlistLimit).map(function(row) { return row.handle; });
  }

  function getWishlistRecords() {
    return parseWishlist(localStorage.getItem(getWishlistStorageKey())).slice(0, wishlistLimit);
  }

  function setWishlistRecords(rows) {
    var normalized = (rows || []).filter(function(row) {
      return row && typeof row.handle === 'string' && row.handle.length > 0;
    }).slice(0, wishlistLimit);
    localStorage.setItem(getWishlistStorageKey(), JSON.stringify(normalized));
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { count: normalized.length, rows: normalized.slice() } }));
  }

  function showWishlistToast(message) {
    if (!wishlistToastEnabled || !message) return;
    var toast = document.getElementById('wishlist-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'wishlist-toast';
      toast.className = 'cart-toast wishlist-toast';
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.classList.add('is-visible');
    clearTimeout(toast._hideTimer);
    toast._hideTimer = setTimeout(function() {
      toast.classList.remove('is-visible');
    }, 1800);
  }

  function setWishlistButtonLoading(btn, loading) {
    if (!btn || !wishlistLoadingEnabled) return;
    btn.classList.toggle('is-loading', !!loading);
    btn.setAttribute('aria-busy', loading ? 'true' : 'false');
  }

  function toggleWishlist(handle, opts) {
    if (!handle || !wishlistEnabled) return false;
    if (wishlistLoggedInOnly && !customerLoggedIn) {
      showWishlistToast('Please log in to use wishlist');
      return false;
    }
    if (!customerLoggedIn && !allowGuestWishlist) {
      showWishlistToast('Guest wishlist is disabled');
      return false;
    }

    var rows = getWishlistRecords();
    var idx = rows.findIndex(function(row) { return row.handle === handle; });
    var now = Date.now();
    var added = false;

    if (idx === -1) {
      if (rows.length >= wishlistLimit) {
        showWishlistToast('Wishlist item limit reached');
        return false;
      }
      rows.unshift({
        handle: handle,
        addedAt: now,
        recentlyAdded: true
      });
      added = true;
    } else {
      rows.splice(idx, 1);
    }

    if (wishlistAutoSave) {
      setWishlistRecords(rows);
    }
    updateWishlistButtons();
    if (opts && opts.btn) {
      setWishlistButtonLoading(opts.btn, false);
      var msg = added
        ? (opts.btn.getAttribute('data-wishlist-success') || 'Added to wishlist')
        : (opts.btn.getAttribute('data-wishlist-remove') || 'Removed from wishlist');
      showWishlistToast(msg);
    }
    return added;
  }

  function updateWishlistButtons() {
    var list = getWishlist();
    var buttons = document.querySelectorAll('.wishlist-toggle');
    buttons.forEach(function(btn) {
      var handle = btn.getAttribute('data-product-handle');
      if (!handle) return;
      var active = list.indexOf(handle) !== -1;
      btn.classList.toggle('is-active', active);
      var activeStyle = btn.getAttribute('data-wishlist-active-style');
      btn.classList.toggle('is-active-outline', active && activeStyle === 'outline');
      btn.classList.toggle('is-active-pulse', active && activeStyle === 'pulse');
      var label = btn.querySelector('.wishlist-toggle__label');
      if (label) {
        label.textContent = active ? 'In wishlist' : (btn.classList.contains('wishlist-toggle--inline') ? 'Add to wishlist' : 'Wishlist');
      }
    });

    var badges = document.querySelectorAll('[data-wishlist-count]');
    badges.forEach(function(badge) {
      var count = list.length;
      badge.textContent = count;
      badge.style.display = count > 0 ? 'inline-block' : 'none';
    });
  }

  function renderWishlistPage() {
    var root = document.querySelector('[data-wishlist-page]');
    if (!root) return;

    var grid = root.querySelector('[data-wishlist-grid]');
    var empty = root.querySelector('[data-wishlist-empty]');
    var actions = root.querySelector('[data-wishlist-actions]');
    if (!grid || !empty) return;

    var showTitle = root.getAttribute('data-wishlist-show-title') !== 'false';
    var showPrice = root.getAttribute('data-wishlist-show-price') !== 'false';
    var showVendor = root.getAttribute('data-wishlist-show-vendor') === 'true';
    var showVariants = root.getAttribute('data-wishlist-show-variants') !== 'false';
    var allowAddToCart = root.getAttribute('data-wishlist-add-to-cart') !== 'false';
    var allowRemove = root.getAttribute('data-wishlist-remove-enabled') !== 'false';
    var allowBulk = root.getAttribute('data-wishlist-bulk-actions') === 'true';
    var moveToCart = root.getAttribute('data-wishlist-move-to-cart') === 'true';
    var allowShare = root.getAttribute('data-wishlist-share') === 'true';
    var layout = root.getAttribute('data-wishlist-layout') || 'grid';
    var columns = parseInt(root.getAttribute('data-wishlist-columns') || '3', 10);

    root.style.setProperty('--wishlist-columns', String(Math.max(2, Math.min(columns, 5))));
    root.classList.toggle('wishlist-page--list', layout === 'list');
    root.classList.toggle('wishlist-page--grid', layout !== 'list');

    var handles = getWishlist();
    if (!handles.length) {
      grid.innerHTML = '';
      empty.style.display = 'block';
      if (actions) actions.style.display = 'none';
      return;
    }

    empty.style.display = 'none';
    if (actions) {
      actions.style.display = allowBulk || allowShare ? 'flex' : 'none';
      var shareBtn = actions.querySelector('[data-wishlist-share]');
      if (shareBtn) shareBtn.style.display = allowShare ? 'inline-flex' : 'none';
    }

    var chunkSize = root.getAttribute('data-wishlist-lazy-load') === 'true' ? 4 : handles.length;
    var offset = 0;

    function renderHandle(handle, done) {
      fetch('/products/' + encodeURIComponent(handle) + '.js')
        .then(function(res) { return res.ok ? res.json() : null; })
        .then(function(product) {
          if (!product) return;
          var item = document.createElement('article');
          item.className = 'product-card wishlist-card';
          item.setAttribute('data-handle', handle);
          item.innerHTML =
            '<label class="wishlist-card__select"><input type="checkbox" data-wishlist-select-item value="' + handle + '"><span></span></label>' +
            '<a href="' + product.url + '" class="product-card__link wishlist-card__link">' +
              '<div class="product-card__media">' +
                '<img src="' + (product.featured_image || '') + '" class="product-card__image" loading="lazy" alt="' + (product.title || '') + '">' +
              '</div>' +
              '<div class="product-card__info">' +
                (showTitle ? ('<h3 class="product-card__title">' + (product.title || '') + '</h3>') : '') +
                (showVendor && product.vendor ? ('<div class="wishlist-card__vendor">' + product.vendor + '</div>') : '') +
                (showPrice ? ('<div class="product-card__price">' + safeFormatMoney(product.price || 0) + '</div>') : '') +
                (showVariants && product.variants && product.variants.length ? ('<div class="wishlist-card__variants">' + product.variants[0].title + '</div>') : '') +
              '</div>' +
            '</a>' +
            '<div class="wishlist-card__actions">' +
              (allowAddToCart && product.variants && product.variants[0] ? '<button type="button" class="button button--secondary" data-wishlist-add-cart="' + product.variants[0].id + '" data-handle="' + handle + '">Add to cart</button>' : '') +
              (allowRemove ? '<button type="button" class="button button--ghost" data-wishlist-remove="' + handle + '">Remove</button>' : '') +
            '</div>';
          if (wishlistRecentBadgeEnabled) {
            var rows = getWishlistRecords();
            var rec = rows.find(function(r) { return r.handle === handle; });
            if (rec && rec.recentlyAdded) {
              item.classList.add('is-recent');
            }
          }
          grid.appendChild(item);
        })
        .finally(function() {
          if (done) done();
        });
    }

    function loadChunk() {
      var end = Math.min(offset + chunkSize, handles.length);
      var pending = end - offset;
      if (pending <= 0) return;
      for (var i = offset; i < end; i += 1) {
        renderHandle(handles[i], function() {
          pending -= 1;
          if (pending === 0) {
            if (end < handles.length) {
              offset = end;
              requestAnimationFrame(loadChunk);
            }
          }
        });
      }
    }

    grid.innerHTML = '';
    loadChunk();

    if (actions) {
      var selectAll = actions.querySelector('[data-wishlist-select-all]');
      var bulkAdd = actions.querySelector('[data-wishlist-bulk-add]');
      var bulkRemove = actions.querySelector('[data-wishlist-bulk-remove]');
      var shareBtn = actions.querySelector('[data-wishlist-share]');

      if (selectAll) {
        selectAll.onchange = function() {
          grid.querySelectorAll('[data-wishlist-select-item]').forEach(function(cb) {
            cb.checked = selectAll.checked;
          });
        };
      }
      if (bulkAdd) {
        bulkAdd.onclick = function() {
          var selected = Array.prototype.slice.call(grid.querySelectorAll('[data-wishlist-select-item]:checked'));
          selected.forEach(function(cb) {
            var card = cb.closest('.wishlist-card');
            var addBtn = card && card.querySelector('[data-wishlist-add-cart]');
            if (addBtn) addBtn.click();
          });
        };
      }
      if (bulkRemove) {
        bulkRemove.onclick = function() {
          var selectedHandles = Array.prototype.slice.call(grid.querySelectorAll('[data-wishlist-select-item]:checked')).map(function(cb) { return cb.value; });
          if (!selectedHandles.length) return;
          var rows = getWishlistRecords().filter(function(r) { return selectedHandles.indexOf(r.handle) === -1; });
          setWishlistRecords(rows);
          renderWishlistPage();
        };
      }
      if (shareBtn) {
        shareBtn.onclick = function() {
          var url = window.location.href;
          if (navigator.share) {
            navigator.share({ title: document.title, url: url }).catch(function() {});
            return;
          }
          navigator.clipboard && navigator.clipboard.writeText(url).then(function() {
            showWishlistToast('Wishlist link copied');
          }).catch(function() {});
        };
      }
    }
  }

  document.addEventListener('click', function(e) {
    if (isDesignMode) return;

    var btn = e.target.closest && e.target.closest('.wishlist-toggle');
    if (btn) {
      e.preventDefault();
      e.stopPropagation();
      setWishlistButtonLoading(btn, true);
      var handle = btn.getAttribute('data-product-handle');
      toggleWishlist(handle, { btn: btn });
      return;
    }

    var removeBtn = e.target.closest && e.target.closest('[data-wishlist-remove]');
    if (removeBtn) {
      e.preventDefault();
      var handleToRemove = removeBtn.getAttribute('data-wishlist-remove');
      var rows = getWishlistRecords().filter(function(r) { return r.handle !== handleToRemove; });
      setWishlistRecords(rows);
      var root = document.querySelector('[data-wishlist-page]');
      var removeMsg = (root && root.getAttribute('data-wishlist-remove')) || 'Removed from wishlist';
      showWishlistToast(removeMsg);
      renderWishlistPage();
      updateWishlistButtons();
      return;
    }

    var addCartBtn = e.target.closest && e.target.closest('[data-wishlist-add-cart]');
    if (addCartBtn) {
      e.preventDefault();
      var variantId = addCartBtn.getAttribute('data-wishlist-add-cart');
      var handleForCart = addCartBtn.getAttribute('data-handle');
      if (!variantId) return;
      setElementLoading(addCartBtn, true);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function(res) { return res.ok ? res.json() : null; })
        .then(function() {
          showCartFeedback('Added to cart');
          var root = document.querySelector('[data-wishlist-page]');
          var move = root && root.getAttribute('data-wishlist-move-to-cart') === 'true';
          if (move && handleForCart) {
            var rows = getWishlistRecords().filter(function(r) { return r.handle !== handleForCart; });
            setWishlistRecords(rows);
            renderWishlistPage();
            updateWishlistButtons();
          }
        })
        .finally(function() {
          setElementLoading(addCartBtn, false);
        });
      return;
    }

  });

  window.addEventListener('storage', function(event) {
    if (event && event.key === getWishlistStorageKey()) {
      updateWishlistButtons();
      renderWishlistPage();
    }
  });
  document.addEventListener('wishlist:updated', function() {
    updateWishlistButtons();
    renderWishlistPage();
  });

  updateWishlistButtons();
  renderWishlistPage();

  // Advanced account login/registration UX
  (function() {
    var root = document.body || document.documentElement;
    if (!root || root.getAttribute('data-accounts-enabled') !== 'true') return;

    var ajaxEnabled = root.getAttribute('data-accounts-ajax') === 'true';
    var loadingEnabled = root.getAttribute('data-accounts-loading') === 'true';
    var strengthEnabled = root.getAttribute('data-accounts-strength') === 'true';
    var showSuccess = root.getAttribute('data-accounts-success-msg') === 'true';
    var showError = root.getAttribute('data-accounts-error-msg') === 'true';
    var redirectMode = root.getAttribute('data-accounts-redirect') || 'account';

    function showAlert(form, type, message) {
      var wrap = form && form.closest('[data-account-form-wrap]');
      if (!wrap) return;
      var alert = wrap.querySelector('[data-account-alert]');
      if (!alert) return;
      if (!message) {
        alert.hidden = true;
        alert.textContent = '';
        alert.classList.remove('is-success', 'is-error');
        return;
      }
      alert.hidden = false;
      alert.textContent = message;
      alert.classList.remove('is-success', 'is-error');
      alert.classList.add(type === 'success' ? 'is-success' : 'is-error');
    }

    function calcStrength(value) {
      var score = 0;
      if (!value) return { label: '', cls: '' };
      if (value.length >= 8) score += 1;
      if (/[A-Z]/.test(value)) score += 1;
      if (/[0-9]/.test(value)) score += 1;
      if (/[^A-Za-z0-9]/.test(value)) score += 1;
      if (score <= 1) return { label: 'Weak password', cls: 'is-weak' };
      if (score <= 3) return { label: 'Medium password', cls: 'is-medium' };
      return { label: 'Strong password', cls: 'is-strong' };
    }

    function bindPasswordStrength(form) {
      if (!strengthEnabled) return;
      var input = form.querySelector('[data-password-input]');
      var meter = form.querySelector('[data-password-strength]');
      if (!input || !meter) return;
      input.addEventListener('input', function() {
        var result = calcStrength(input.value || '');
        meter.textContent = result.label;
        meter.classList.remove('is-weak', 'is-medium', 'is-strong');
        if (result.cls) meter.classList.add(result.cls);
      });
    }

    function bindRecoverToggle() {
      document.querySelectorAll('[data-toggle-recover]').forEach(function(link) {
        link.addEventListener('click', function(e) {
          e.preventDefault();
          var formWrap = link.closest('[data-account-form-wrap]');
          if (!formWrap) return;
          var recover = formWrap.querySelector('[data-recover-form]');
          if (!recover) return;
          recover.hidden = !recover.hidden;
        });
      });
    }

    function bindMultiStep(form) {
      if (form.getAttribute('data-multistep') !== 'true') return;
      var step1 = form.querySelector('[data-account-step="1"]');
      var step2 = form.querySelector('[data-account-step="2"]');
      var prevBtn = form.querySelector('[data-account-prev]');
      var nextBtn = form.querySelector('[data-account-next]');
      var submitBtn = form.querySelector('[data-account-submit]');
      if (!step1 || !step2 || !nextBtn || !submitBtn) return;

      step1.classList.add('is-visible');
      step2.classList.remove('is-visible');
      if (prevBtn) prevBtn.hidden = true;
      submitBtn.hidden = true;

      nextBtn.addEventListener('click', function() {
        step1.classList.remove('is-visible');
        step2.classList.add('is-visible');
        if (prevBtn) prevBtn.hidden = false;
        nextBtn.hidden = true;
        submitBtn.hidden = false;
      });

      if (prevBtn) {
        prevBtn.addEventListener('click', function() {
          step2.classList.remove('is-visible');
          step1.classList.add('is-visible');
          prevBtn.hidden = true;
          nextBtn.hidden = false;
          submitBtn.hidden = true;
        });
      }
    }

    function validateForm(form) {
      var confirm = form.querySelector('[data-password-confirm]');
      var pwd = form.querySelector('[data-password-input]');
      if (confirm && pwd && confirm.value !== pwd.value) {
        showAlert(form, 'error', 'Password confirmation does not match.');
        return false;
      }
      return true;
    }

    function resolveRedirect() {
      if (redirectMode === 'home') return '/';
      if (redirectMode === 'last') return sessionStorage.getItem('mogi_last_visited_url') || '/account';
      return '/account';
    }

    function bindAjaxForms() {
      var forms = document.querySelectorAll('.js-account-form');
      forms.forEach(function(form) {
        bindPasswordStrength(form);
        bindMultiStep(form);

        form.addEventListener('submit', function(e) {
          if (!validateForm(form)) {
            e.preventDefault();
            return;
          }
          if (!ajaxEnabled) return;
          e.preventDefault();
          showAlert(form, '', '');
          var wrap = form.closest('.account-form');
          if (wrap && loadingEnabled) wrap.classList.add('is-loading');

          fetch(form.action, {
            method: 'POST',
            body: new FormData(form),
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
          })
            .then(function(res) {
              if (res.redirected) {
                window.location.href = res.url;
                return Promise.reject({ redirected: true });
              }
              return res.text().then(function(html) {
                return { ok: res.ok, html: html };
              });
            })
            .then(function(result) {
              if (result.ok) {
                if (showSuccess) showAlert(form, 'success', 'Success. Redirecting...');
                window.location.href = resolveRedirect();
                return;
              }
              if (showError) showAlert(form, 'error', 'Please check your details and try again.');
            })
            .catch(function(err) {
              if (err && err.redirected) return;
              if (showError) showAlert(form, 'error', 'Unable to submit form right now.');
            })
            .finally(function() {
              if (wrap) wrap.classList.remove('is-loading');
            });
        });
      });
    }

    bindRecoverToggle();
    bindAjaxForms();

    window.addEventListener('beforeunload', function() {
      sessionStorage.setItem('mogi_last_visited_url', window.location.href || '/');
    });
  })();

  // AJAX add-to-cart with small animation + toast
  function showCartFeedback(message) {
    var cartIcon = document.getElementById('cart-icon');
    if (cartIcon) {
      cartIcon.classList.add('cart-icon--pulse');
      setTimeout(function() {
        cartIcon.classList.remove('cart-icon--pulse');
      }, 400);
    }

    var toast = document.getElementById('cart-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'cart-toast';
      toast.className = 'cart-toast';
      document.body.appendChild(toast);
    }
    toast.textContent = message || 'Added to cart';
    toast.classList.add('is-visible');
    clearTimeout(toast._hideTimer);
    toast._hideTimer = setTimeout(function() {
      toast.classList.remove('is-visible');
    }, 2200);
  }

  function openQuickView(handle) {
    if (!handle) return;
    var modal = document.getElementById('quick-view-modal');
    if (!modal) {
      modal = document.createElement('div');
      modal.id = 'quick-view-modal';
      modal.className = 'quick-view-modal';
      modal.innerHTML = '<div class="quick-view-modal__overlay" data-qv-close></div><div class="quick-view-modal__panel"><button type="button" class="quick-view-modal__close" data-qv-close>&times;</button><div class="quick-view-modal__content" data-qv-content></div></div>';
      document.body.appendChild(modal);
      modal.addEventListener('click', function(e) {
        if (e.target && e.target.hasAttribute('data-qv-close')) {
          modal.classList.remove('is-open');
        }
      });
    }
    var content = modal.querySelector('[data-qv-content]');
    if (content) content.innerHTML = '<p>Loading...</p>';
    modal.classList.add('is-open');
    fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function(res) { return res.ok ? res.json() : null; })
      .then(function(product) {
        if (!product || !content) return;
        var imageHtml = product.featured_image ? '<img src="' + product.featured_image + '" alt="' + (product.title || '') + '" loading="lazy">' : '';
        content.innerHTML = '<div class="quick-view-modal__grid"><div class="quick-view-modal__media">' + imageHtml + '</div><div class="quick-view-modal__meta"><h3>' + (product.title || '') + '</h3><div class="quick-view-modal__price">' + safeFormatMoney(product.price || 0) + '</div><a class="button" href="' + (product.url || '#') + '">View product</a></div></div>';
      })
      .catch(function() {
        if (content) content.innerHTML = '<p>Could not load quick view.</p>';
      });
  }

  function setElementLoading(el, isLoading) {
    if (!el) return;
    if (isLoading) {
      el.classList.add('is-loading');
      el.setAttribute('aria-busy', 'true');
      if (el.tagName === 'BUTTON' || el.tagName === 'INPUT') {
        el.disabled = true;
      }
      return;
    }
    el.classList.remove('is-loading');
    el.removeAttribute('aria-busy');
    if (el.tagName === 'BUTTON' || el.tagName === 'INPUT') {
      el.disabled = false;
    }
  }

  function showButtonSuccess(el) {
    if (!el) return;
    clearTimeout(el._successTimer);
    if (!el.dataset.originalLabel) {
      el.dataset.originalLabel = (el.textContent || '').trim();
    }
    el.classList.add('is-success');
    el.setAttribute('aria-live', 'polite');
    el.textContent = 'Added';
    el._successTimer = setTimeout(function() {
      el.classList.remove('is-success');
      if (el.dataset.originalLabel) {
        el.textContent = el.dataset.originalLabel;
      }
    }, 1300);
  }

  function announceCartMessage(type, message) {
    var cartSection = document.querySelector('[data-cart-section]');
    if (!cartSection) return;
    var target = type === 'error'
      ? cartSection.querySelector('[data-cart-errors]')
      : cartSection.querySelector('[data-cart-status]');
    if (!target) return;
    target.textContent = '';
    setTimeout(function() {
      target.textContent = message || '';
    }, 12);
  }

  function setCartPromoFeedback(message, isError) {
    var el = document.querySelector('[data-cart-promo-feedback]');
    if (!el) return;
    if (!message) {
      el.textContent = '';
      el.setAttribute('hidden', '');
      el.classList.remove('cart-main__promo-feedback--error', 'cart-main__promo-feedback--success');
      return;
    }
    el.textContent = message;
    el.removeAttribute('hidden');
    el.classList.toggle('cart-main__promo-feedback--error', !!isError);
    el.classList.toggle('cart-main__promo-feedback--success', !isError);
  }

  var CART_DISCOUNT_GENERIC_ERR =
    "That code isn't valid for this cart. Check spelling, dates, and any minimum spend — then try again.";

  function setCartDiscountInputInvalid(on) {
    var el = document.querySelector('[data-cart-discount-input]');
    if (!el) return;
    el.classList.toggle('mogi-cart-discount-input--invalid', !!on);
    el.setAttribute('aria-invalid', on ? 'true' : 'false');
  }

  function extractCartDiscountApiMessage(data) {
    if (data == null) return '';
    if (typeof data === 'string') return data.trim();
    if (typeof data !== 'object') return '';
    var msg = (data.description || data.message || '').trim();
    if (msg) return msg;
    if (data.error && typeof data.error === 'string') return data.error.trim();
    if (data.errors) {
      if (typeof data.errors === 'string') return data.errors.trim();
      if (Array.isArray(data.errors) && data.errors.length) return data.errors.join(' ').trim();
      var eb = data.errors.base;
      if (Array.isArray(eb) && eb.length) return eb.join(' ').trim();
      if (data.errors.discount) {
        var dd = data.errors.discount;
        return Array.isArray(dd) ? dd.join(' ').trim() : String(dd).trim();
      }
      try {
        var parts = [];
        Object.keys(data.errors).forEach(function(k) {
          var v = data.errors[k];
          if (Array.isArray(v)) v.forEach(function(x) { parts.push(String(x)); });
          else if (v != null) parts.push(String(v));
        });
        if (parts.length) return parts.join(' ').trim();
      } catch (e) {}
    }
    return '';
  }

  function cartDiscountUpdateLooksRejected(res, data) {
    if (!res || !res.ok) return true;
    if (!data || typeof data !== 'object') return false;
    var st = data.status;
    if (Number(st) === 422 || st === '422') return true;
    if (data.error && typeof data.error === 'string' && data.error.trim()) return true;
    return false;
  }

  function formatCartDiscountFailureMessage(res, data) {
    var extracted = extractCartDiscountApiMessage(data);
    if (extracted) return extracted;
    if (res && res.status === 404) return 'Cart could not be updated. Refresh the page and try again.';
    return CART_DISCOUNT_GENERIC_ERR;
  }

  function userFacingDiscountError(errMessage) {
    var msg = (errMessage || '').trim() || CART_DISCOUNT_GENERIC_ERR;
    if (msg.indexOf('already applied') !== -1) return msg;
    if (msg === CART_DISCOUNT_GENERIC_ERR) return msg;
    if (/^code not accepted/i.test(msg)) return msg;
    return 'Code not accepted — ' + msg;
  }

  function bindAjaxAddToCartForm(form) {
    if (!form || form.dataset.ajaxCartBound === 'true') return;
    form.dataset.ajaxCartBound = 'true';
    form.addEventListener('submit', function(e) {
      var fileInputs = form.querySelectorAll('input[type="file"]');
      var hasFileSelected = false;
      for (var fi = 0; fi < fileInputs.length; fi++) {
        if (fileInputs[fi].files && fileInputs[fi].files.length > 0) {
          hasFileSelected = true;
          break;
        }
      }
      if (hasFileSelected) {
        return;
      }
      e.preventDefault();
      var submitBtn = form.querySelector('.product-main__add-to-cart, [type="submit"]');
      if (submitBtn && !submitBtn.dataset.originalLabel) {
        submitBtn.dataset.originalLabel = (submitBtn.textContent || '').trim();
      }
      setElementLoading(submitBtn, true);

      var data = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        body: data,
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/json'
        }
      })
        .then(function(res) {
          return res.json().then(function(body) {
            return { ok: res.ok, body: body };
          }).catch(function() {
            return { ok: res.ok, body: null };
          });
        })
        .then(function(result) {
          if (!result.ok) {
            var errMsg = 'Could not add to cart';
            var b = result.body;
            if (b) {
              if (typeof b.description === 'string' && b.description) {
                errMsg = b.description;
              } else if (typeof b.message === 'string' && b.message) {
                errMsg = b.message;
              } else if (typeof b.error === 'string' && b.error) {
                errMsg = b.error;
              }
            }
            announceCartMessage('error', errMsg);
            showCartFeedback(errMsg);
            return;
          }

          fetch('/cart.js')
            .then(function(r) { return r.json(); })
            .then(function(cart) {
              updateCartCount();
              if (document.body && document.body.getAttribute('data-premium-cart-auto-open') === 'true') {
                openCartDrawer(cart);
              }
            });

          var title = form.getAttribute('data-product-title') || 'Product';
          var success = '“' + title + '” added to cart';
          announceCartMessage('status', success);
          showCartFeedback(success);
          showButtonSuccess(submitBtn);
        })
        .catch(function() {
          announceCartMessage('error', 'Could not add to cart');
          showCartFeedback('Could not add to cart');
        })
        .finally(function() {
          setElementLoading(submitBtn, false);
        });
    });
  }

  var ajaxForms = document.querySelectorAll('form.js-ajax-add-to-cart');
  ajaxForms.forEach(function(form) { bindAjaxAddToCartForm(form); });

  document.addEventListener('click', function(e) {
    var quickViewBtn = e.target.closest && e.target.closest('[data-quick-view-handle]');
    if (!quickViewBtn) return;
    e.preventDefault();
    openQuickView(quickViewBtn.getAttribute('data-quick-view-handle'));
  });

  (function initCartCountdown() {
    if (!document.body || document.body.getAttribute('data-premium-cart-countdown-enable') !== 'true') return;
    var nodes = document.querySelectorAll('[data-cart-countdown]');
    if (!nodes.length) return;
    nodes.forEach(function(node) {
      var target = node.querySelector('[data-cart-countdown-time]');
      var mins = parseInt(node.getAttribute('data-minutes') || document.body.getAttribute('data-premium-cart-countdown-minutes') || '15', 10);
      var endsAt = Date.now() + (Math.max(mins, 1) * 60 * 1000);
      function tick() {
        var remaining = Math.max(0, Math.floor((endsAt - Date.now()) / 1000));
        var mm = String(Math.floor(remaining / 60)).padStart(2, '0');
        var ss = String(remaining % 60).padStart(2, '0');
        if (target) target.textContent = mm + ':' + ss;
        if (remaining <= 0) return;
        setTimeout(tick, 1000);
      }
      tick();
    });
  })();

  // Cart icon click opens drawer with current cart
  var cartToggle = document.getElementById('cart-icon');
  if (cartToggle) {
    cartToggle.addEventListener('click', function(e) {
      if (isDesignMode) return;
      e.preventDefault();
      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          openCartDrawer(cart);
        });
    });
  }

  var cartOverlay = document.querySelector('[data-cart-overlay]');
  if (cartOverlay) {
    cartOverlay.addEventListener('click', closeCartDrawer);
  }
  var cartClose = document.querySelector('.cart-drawer__close');
  if (cartClose) {
    cartClose.addEventListener('click', closeCartDrawer);
  }

  // Remove item directly from mini cart
  document.addEventListener('click', function(e) {
    var removeBtn = e.target.closest && e.target.closest('[data-cart-drawer-remove]');
    if (!removeBtn) return;
    e.preventDefault();
    var key = removeBtn.getAttribute('data-cart-drawer-remove');
    if (!key) return;
    removeBtn.disabled = true;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: key,
        quantity: 0
      })
    })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        updateCartCount();
        openCartDrawer(cart);
      })
      .catch(function() {
        window.location.href = '/cart';
      })
      .finally(function() {
        removeBtn.disabled = false;
      });
  });

  function getDiscountCodesFromCartJson(cart) {
    if (!cart || !cart.discount_codes) return [];
    if (!Array.isArray(cart.discount_codes)) return [];
    var out = [];
    cart.discount_codes.forEach(function(d) {
      if (typeof d === 'string' && d.trim()) out.push(d.trim());
      else if (d && typeof d.code === 'string' && d.code.trim()) out.push(d.code.trim());
    });
    return out;
  }

  /** Codes Shopify will actually honour (excludes applicable:false entries when the flag exists). */
  function getApplicableDiscountCodesFromCart(cart) {
    if (!cart || !cart.discount_codes) return [];
    if (!Array.isArray(cart.discount_codes)) return [];
    var out = [];
    cart.discount_codes.forEach(function(d) {
      if (typeof d === 'string' && d.trim()) {
        out.push(d.trim());
      } else if (d && typeof d.code === 'string' && d.code.trim()) {
        if (d.applicable === false) return;
        out.push(d.code.trim());
      }
    });
    return out;
  }

  function cartDiscountCodesHaveApplicableFlags(cart) {
    if (!cart || !Array.isArray(cart.discount_codes)) return false;
    for (var i = 0; i < cart.discount_codes.length; i++) {
      var d = cart.discount_codes[i];
      if (d && typeof d === 'object' && 'applicable' in d) return true;
    }
    return false;
  }

  function getDiscountCodeEntryState(cart, codeStr) {
    var lower = String(codeStr).toLowerCase();
    var found = false;
    var applicable = null;
    if (!cart || !Array.isArray(cart.discount_codes)) return { found: false, applicable: null };
    cart.discount_codes.forEach(function(d) {
      var c = typeof d === 'string' ? d.trim() : d && d.code ? String(d.code).trim() : '';
      if (!c || c.toLowerCase() !== lower) return;
      found = true;
      if (d && typeof d === 'object' && 'applicable' in d) applicable = !!d.applicable;
    });
    return { found: found, applicable: applicable };
  }

  function cartHasInapplicableDiscountCodes(cart) {
    if (!cart || !Array.isArray(cart.discount_codes)) return false;
    for (var i = 0; i < cart.discount_codes.length; i++) {
      var d = cart.discount_codes[i];
      if (d && typeof d === 'object' && d.applicable === false) return true;
    }
    return false;
  }

  function stripInapplicableDiscountCodes(cart) {
    if (!cart || !cartHasInapplicableDiscountCodes(cart)) {
      return Promise.resolve(cart);
    }
    var next = getApplicableDiscountCodesFromCart(cart);
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ discount: next.join(',') })
    })
      .then(function(res) {
        return res.json().then(function(data) {
          if (!res.ok) return cart;
          return data;
        });
      })
      .catch(function() {
        return cart;
      });
  }

  /** Match cart_level_discount_applications entry to a customer code (order is not guaranteed). */
  function findDiscountAllocationForCode(apps, codeStr) {
    if (!Array.isArray(apps) || !codeStr) return null;
    var lower = String(codeStr).toLowerCase();
    for (var i = 0; i < apps.length; i++) {
      var a = apps[i];
      if (!a || typeof a !== 'object') continue;
      var codeField = a.code != null ? String(a.code) : '';
      var titleField = a.title != null ? String(a.title) : '';
      if (codeField && codeField.toLowerCase() === lower) return a;
      if (titleField && titleField.toLowerCase() === lower) return a;
    }
    if (apps.length === 1) return apps[0];
    return null;
  }

  /**
   * Stated coupon % from Shopify (e.g. 40% off), never savings/subtotal math (which skews to values like 66%).
   */
  function cartDiscountPercentLabelFromAlloc(alloc) {
    if (!alloc || typeof alloc !== 'object') return '';
    var vt = String(alloc.value_type || '').toLowerCase();
    if (vt !== 'percentage' || alloc.value == null || alloc.value === '') return '';
    var raw = Number(String(alloc.value).replace(/,/g, ''));
    if (!isFinite(raw) || raw <= 0) return '';
    var pct = raw > 0 && raw <= 1 ? raw * 100 : raw;
    if (pct > 100) return '';
    var rounded = Math.round(pct * 100) / 100;
    if (Math.abs(rounded - Math.round(rounded)) < 0.001) {
      return String(Math.round(rounded)) + '%';
    }
    return rounded.toFixed(1).replace(/\.0$/, '') + '%';
  }

  /**
   * When API omits percentage fields, infer from codes like spring40 → 40% (letters + 1–2 trailing digits only).
   */
  function inferPercentFromDiscountCode(codeStr) {
    var m = String(codeStr || '').match(/^([A-Za-z_-]+)(\d{1,2})$/i);
    if (!m) return '';
    var n = parseInt(m[2], 10);
    if (n < 1 || n > 99) return '';
    return String(n) + '%';
  }

  function renderCartAppliedCodes(cart) {
    var wrap = document.querySelector('[data-cart-applied-codes]');
    if (!wrap) return;
    wrap.innerHTML = '';
    var codes = getApplicableDiscountCodesFromCart(cart);
    if (!codes.length) {
      wrap.setAttribute('hidden', '');
      return;
    }
    wrap.removeAttribute('hidden');

    var apps = Array.isArray(cart.cart_level_discount_applications) ? cart.cart_level_discount_applications : [];

    var titleEl = document.createElement('div');
    titleEl.className = 'cart-main__applied-codes-heading';
    titleEl.textContent = (wrap.getAttribute('data-applied-heading') || 'Applied promo codes').trim();

    var detailPrefix = (wrap.getAttribute('data-code-detail-line') || '').trim();

    var list = document.createElement('ul');
    list.className = 'cart-main__applied-codes-list';

    codes.forEach(function(codeStr) {
      var alloc = findDiscountAllocationForCode(apps, codeStr);
      if (!alloc && codes.length === 1 && apps.length === 1) {
        alloc = apps[0];
      }

      var li = document.createElement('li');
      li.className = 'cart-main__applied-codes-item';

      var body = document.createElement('div');
      body.className = 'cart-main__applied-codes-item-body';

      var line = document.createElement('div');
      line.className = 'cart-main__applied-codes-item-line';

      var main = document.createElement('div');
      main.className = 'cart-main__applied-line';

      var codeSpan = document.createElement('span');
      codeSpan.className = 'cart-main__applied-code';
      codeSpan.textContent = codeStr;

      var pctStr = cartDiscountPercentLabelFromAlloc(alloc) || inferPercentFromDiscountCode(codeStr);
      if (pctStr) {
        var pctSpan = document.createElement('span');
        pctSpan.className = 'cart-main__applied-code-pct';
        pctSpan.textContent = detailPrefix ? detailPrefix + ' ' + pctStr : pctStr;
        main.appendChild(codeSpan);
        main.appendChild(pctSpan);
      } else {
        main.appendChild(codeSpan);
      }

      var rm = document.createElement('button');
      rm.type = 'button';
      rm.className = 'cart-main__applied-code-remove cart-main__applied-code-remove--compact';
      rm.setAttribute('data-cart-remove-code', codeStr);
      rm.setAttribute('aria-label', 'Remove promo code ' + codeStr);
      rm.innerHTML = '<span aria-hidden="true">×</span>';

      line.appendChild(main);
      line.appendChild(rm);
      body.appendChild(line);

      li.appendChild(body);
      list.appendChild(li);
    });

    wrap.appendChild(titleEl);
    wrap.appendChild(list);
  }

  function syncCartAppliedCodes() {
    return fetch('/cart.js')
      .then(function(r) {
        return r.json();
      })
      .then(function(cart) {
        return stripInapplicableDiscountCodes(cart);
      })
      .then(function(cart) {
        renderCartAppliedCodes(cart);
        return cart;
      })
      .catch(function() {
        var wrap = document.querySelector('[data-cart-applied-codes]');
        if (wrap) {
          wrap.innerHTML = '';
          wrap.setAttribute('hidden', '');
        }
      });
  }

  function refreshMainCartSectionHtml() {
    var current = document.querySelector('[data-cart-section]');
    if (!current) return Promise.resolve();
    var sectionId = current.getAttribute('data-section-id');
    if (!sectionId) return Promise.resolve();
    return fetch(window.location.pathname + '?section_id=' + encodeURIComponent(sectionId), {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function(r) {
        if (!r.ok) throw new Error('Failed to refresh cart');
        return r.text();
      })
      .then(function(html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var next = doc.querySelector('[data-cart-section]');
        var cur = document.querySelector('[data-cart-section]');
        if (!next || !cur || !cur.parentNode) return;
        cur.parentNode.replaceChild(next, cur);
        initCartPageAjax();
      });
  }

  function removeCartDiscountCodeFromCart(codeToRemove) {
    if (!codeToRemove) return Promise.resolve();
    var cs = document.querySelector('[data-cart-section]');
    if (cs) cs.classList.add('is-cart-section-refreshing');
    return fetch('/cart.js')
      .then(function(r) {
        return r.json();
      })
      .then(function(cart) {
        var codes = getDiscountCodesFromCartJson(cart);
        var next = codes.filter(function(c) {
          return c.toLowerCase() !== String(codeToRemove).toLowerCase();
        });
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ discount: next.join(',') })
        }).then(function(res) {
          return res.json().then(function(data) {
            if (!res.ok) {
              var msg = (data && (data.description || data.message)) || 'Could not remove code';
              throw new Error(msg);
            }
            return data;
          });
        });
      })
      .then(function() {
        return refreshMainCartSectionHtml();
      })
      .then(function() {
        updateCartCount();
        setCartPromoFeedback('Promo code removed. Totals above are updated.', false);
        announceCartMessage('status', 'Promo code removed.');
      })
      .catch(function(err) {
        var msg = (err && err.message) || 'Could not remove code';
        setCartPromoFeedback(msg, true);
        announceCartMessage('error', msg);
      })
      .finally(function() {
        var fresh = document.querySelector('[data-cart-section]');
        if (fresh) fresh.classList.remove('is-cart-section-refreshing');
      });
  }

  if (!window.__mogiCartDiscountRemoveBound) {
    window.__mogiCartDiscountRemoveBound = true;
    document.addEventListener('click', function(e) {
      var btn = e.target.closest && e.target.closest('[data-cart-remove-code]');
      if (!btn) return;
      if (!document.querySelector('[data-cart-section]')) return;
      e.preventDefault();
      var c = btn.getAttribute('data-cart-remove-code');
      if (!c) return;
      removeCartDiscountCodeFromCart(c);
    });
  }

  // Cart page: AJAX quantity/remove with loading and section re-render
  function initCartPageAjax() {
    var cartSection = document.querySelector('[data-cart-section]');
    var cartForm = cartSection ? cartSection.querySelector('[data-cart-auto-update]') : null;
    if (!cartSection) return;

    syncCartAppliedCodes();

    var addForms = cartSection.querySelectorAll('form[action="/cart/add"], form[action^="/cart/add?"], form[data-ajax-cart-add]');
    addForms.forEach(function(form) { bindAjaxAddToCartForm(form); });

    if (!cartForm) return;

    var qtyInputs = cartForm.querySelectorAll('[data-cart-qty]');
    if (!qtyInputs.length) return;

    function syncCartLineIndices(cart) {
      if (!cart || !cart.items) return;
      for (var i = 0; i < cart.items.length; i++) {
        var item = cart.items[i];
        var lineNum = String(i + 1);
        var cards = cartForm.querySelectorAll('.cart-main__item-card');
        for (var c = 0; c < cards.length; c++) {
          if (cards[c].getAttribute('data-line-key') === item.key) {
            cards[c].setAttribute('data-line', lineNum);
            var inp = cards[c].querySelector('[data-cart-qty]');
            var rm = cards[c].querySelector('[data-cart-remove]');
            if (inp) inp.setAttribute('data-line', lineNum);
            if (rm) rm.setAttribute('data-line', lineNum);
            break;
          }
        }
      }
    }

    function getCartSaleLabels(cs) {
      if (!cs) {
        return { badge: 'Sale', prefix: 'You save', suffix: 'on this item', promo: 'Special price' };
      }
      return {
        badge: cs.getAttribute('data-sale-badge') || 'Sale',
        prefix: cs.getAttribute('data-sale-prefix') || 'You save',
        suffix: cs.getAttribute('data-sale-suffix') || 'on this item',
        promo: cs.getAttribute('data-sale-promo') || 'Special price'
      };
    }

    function updateCartLinePricingFromItem(row, item, cartSection) {
      if (!row || !item) return;
      var cs = cartSection || document.querySelector('[data-cart-section]');
      var labels = getCartSaleLabels(cs);
      var priceEl = row.querySelector('[data-cart-price]');
      if (priceEl) {
        var op = item.original_price;
        var p = item.price;
        var priceHtml = '';
        if (op != null && p != null && op > p) {
          priceHtml = '<s class="cart-main__compare-at">' + safeFormatMoney(op) + '</s> ';
        }
        priceHtml += safeFormatMoney(p);
        priceEl.innerHTML = priceHtml;
      }

      var allocs = item.line_level_discount_allocations;
      if (!allocs || !allocs.length) {
        allocs = item.discounts;
      }
      if (!allocs || !allocs.length) {
        allocs = [];
      }
      var origLine = item.original_line_price;
      var lineP = item.line_price;
      var origUnit = item.original_price;
      var unitP = item.price;
      var qty = item.quantity || 1;

      var onSale = false;
      if (allocs.length) {
        onSale = true;
      } else if (origLine != null && lineP != null && origLine > lineP) {
        onSale = true;
      } else if (origUnit != null && unitP != null && origUnit > unitP) {
        onSale = true;
      }

      var saleEl = row.querySelector('[data-cart-sale-row]');
      if (!onSale) {
        if (saleEl) {
          saleEl.remove();
        }
        return;
      }

      var badgeHtml = '<span class="cart-main__sale-badge">' + escapeHtml(labels.badge) + '</span>';
      var inner = '';
      if (allocs.length) {
        inner += '<div class="cart-main__sale-discounts">';
        for (var ai = 0; ai < allocs.length; ai++) {
          var a = allocs[ai];
          var app = a.discount_application || {};
          var title = app.title || a.title || a.discount_title || 'Discount';
          var amt = 0;
          if (typeof a.amount === 'number') {
            amt = a.amount;
          } else if (typeof a.total_allocated_amount === 'number') {
            amt = a.total_allocated_amount;
          }
          inner +=
            '<div class="cart-main__line-discount">' +
            escapeHtml(title) +
            ' (−' +
            safeFormatMoney(amt) +
            ')</div>';
        }
        inner += '</div>';
      } else if (origLine != null && lineP != null && origLine > lineP) {
        var saveLine = origLine - lineP;
        inner =
          '<span class="cart-main__sale-text">' +
          escapeHtml(labels.prefix) +
          ' <strong>' +
          safeFormatMoney(saveLine) +
          '</strong> ' +
          escapeHtml(labels.suffix) +
          '</span>';
      } else if (origUnit != null && unitP != null && origUnit > unitP) {
        var saveUnits = (origUnit - unitP) * qty;
        inner =
          '<span class="cart-main__sale-text">' +
          escapeHtml(labels.prefix) +
          ' <strong>' +
          safeFormatMoney(saveUnits) +
          '</strong> ' +
          escapeHtml(labels.suffix) +
          '</span>';
      } else {
        inner = '<span class="cart-main__sale-text">' + escapeHtml(labels.promo) + '</span>';
      }

      if (saleEl) {
        saleEl.innerHTML = badgeHtml + inner;
      } else {
        saleEl = document.createElement('div');
        saleEl.className = 'cart-main__sale-message';
        saleEl.setAttribute('role', 'status');
        saleEl.setAttribute('data-cart-sale-row', '');
        saleEl.innerHTML = badgeHtml + inner;
        var header = row.querySelector('.cart-main__item-header');
        if (header && header.parentNode) {
          header.insertAdjacentElement('afterend', saleEl);
        }
      }
    }

    function syncAllCartLinePricing(cart, cartSection) {
      if (!cart || !cart.items || !cartSection) return;
      var cards = cartSection.querySelectorAll('.cart-main__item-card[data-line-key]');
      for (var c = 0; c < cards.length; c++) {
        var card = cards[c];
        var k = card.getAttribute('data-line-key');
        if (!k) continue;
        var match = null;
        for (var i = 0; i < cart.items.length; i++) {
          if (cart.items[i].key === k) {
            match = cart.items[i];
            break;
          }
        }
        if (!match) continue;
        var lt = card.querySelector('[data-cart-line-total]');
        if (lt) {
          var lineCents =
            typeof match.final_line_price === 'number'
              ? match.final_line_price
              : typeof match.line_price === 'number'
                ? match.line_price
                : typeof match.price === 'number' && match.quantity
                  ? match.price * match.quantity
                  : 0;
          lt.textContent = safeFormatMoney(lineCents);
        }
        updateCartLinePricingFromItem(card, match, cartSection);
      }
    }

    function refreshCartSection() {
      return refreshMainCartSectionHtml();
    }

    function updateCartLine(input) {
      var key = input.getAttribute('data-line-key');
      var quantity = parseInt(input.value, 10);
      if (!key || isNaN(quantity) || quantity < 0) return;

      var row = input.closest('.cart-main__item-card');
      var line = parseInt(input.getAttribute('data-line'), 10);
      if (row && (isNaN(line) || line < 1)) {
        line = parseInt(row.getAttribute('data-line'), 10);
      }
      if (isNaN(line) || line < 1) return;

      var removeBtn = row ? row.querySelector('[data-cart-remove]') : null;
      var lineTotal = row ? row.querySelector('[data-cart-line-total]') : null;
      var subtotal = cartForm.querySelector('[data-cart-subtotal]');

      if (row) row.classList.add('is-cart-line-busy');
      input.classList.add('is-updating');
      input.setAttribute('aria-busy', 'true');
      input.disabled = true;
      if (removeBtn && quantity === 0) setElementLoading(removeBtn, true);

      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          line: line,
          quantity: quantity
        })
      })
        .then(function(res) {
          return res.json().then(function(data) {
            if (!res.ok) {
              var msg = (data && (data.description || data.message)) || 'Error updating cart';
              throw new Error(msg);
            }
            return data;
          });
        })
        .then(function(cart) {
          if (!cart) return;

          var emptyCart = !cart.items || cart.item_count === 0;

          if (cartSection) {
            cartSection.classList.add('is-cart-section-refreshing');
          }

          return refreshCartSection()
            .then(function() {
              updateCartCount();
              if (emptyCart) {
                announceCartMessage('status', 'Cart updated. Your cart is now empty.');
              } else {
                announceCartMessage('status', quantity === 0 ? 'Item removed from cart.' : 'Cart updated.');
              }
            })
            .catch(function(refreshErr) {
              announceCartMessage(
                'error',
                (refreshErr && refreshErr.message) || 'Could not refresh cart. Please reload the page.'
              );
            })
            .finally(function() {
              var freshSection = document.querySelector('[data-cart-section]');
              if (freshSection) {
                freshSection.classList.remove('is-cart-section-refreshing');
              }
            });
        })
        .catch(function(err) {
          announceCartMessage('error', (err && err.message) || 'Error updating cart');
          showCartFeedback((err && err.message) || 'Error updating cart');
        })
        .finally(function() {
          input.classList.remove('is-updating');
          input.disabled = false;
          input.removeAttribute('aria-busy');
          if (row && row.parentNode) {
            row.classList.remove('is-cart-line-busy');
            var rbtn = row.querySelector('[data-cart-remove]');
            if (rbtn) setElementLoading(rbtn, false);
          }
        });
    }

    qtyInputs.forEach(function(input) {
      var debounceTimer;
      input.addEventListener('input', function() {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(function() {
          updateCartLine(input);
        }, 250);
      });
      input.addEventListener('change', function() {
        updateCartLine(input);
      });
    });

    cartForm.addEventListener('click', function(e) {
      var removeBtn = e.target.closest && e.target.closest('[data-cart-remove]');
      if (!removeBtn) return;
      e.preventDefault();
      var key = removeBtn.getAttribute('data-line-key');
      if (!key) return;
      setElementLoading(removeBtn, true);
      var qtyInput = cartForm.querySelector('[data-cart-qty][data-line-key="' + key + '"]');
      if (!qtyInput) {
        setElementLoading(removeBtn, false);
        return;
      }
      qtyInput.value = 0;
      updateCartLine(qtyInput);
    });

    var discountInput = cartForm.querySelector('[data-cart-discount-input]');
    var discountApplyBtn = cartForm.querySelector('[data-cart-apply-discount]');
    function applyCartDiscountCode() {
      if (!discountInput || !discountApplyBtn) return;
      var code = (discountInput.value || '').trim();
      if (!code) {
        setCartPromoFeedback('Enter a discount code first.', true);
        announceCartMessage('error', 'Enter a discount code first.');
        discountInput.focus();
        return;
      }
      setCartPromoFeedback('', false);
      setCartDiscountInputInvalid(false);
      discountApplyBtn.disabled = true;
      discountApplyBtn.setAttribute('aria-busy', 'true');
      fetch('/cart.js')
        .then(function(r) {
          return r.json();
        })
        .catch(function() {
          return null;
        })
        .then(function(cartJson) {
          var newCode = code.trim();
          var existing = [];
          var merged = newCode;
          if (cartJson) {
            existing = getApplicableDiscountCodesFromCart(cartJson);
            if (
              existing.some(function(c) {
                return c.toLowerCase() === newCode.toLowerCase();
              })
            ) {
              throw new Error('That code is already applied.');
            }
            merged = existing.concat([newCode]).join(',');
          }
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({ discount: merged })
          }).then(function(res) {
            return res.text().then(function(text) {
              var data = {};
              try {
                data = text ? JSON.parse(text) : {};
              } catch (parseErr) {
                if (!res.ok) {
                  throw new Error(formatCartDiscountFailureMessage(res, null));
                }
                throw new Error(CART_DISCOUNT_GENERIC_ERR);
              }
              if (cartDiscountUpdateLooksRejected(res, data)) {
                throw new Error(formatCartDiscountFailureMessage(res, data));
              }
              var hasFlags = cartDiscountCodesHaveApplicableFlags(data);
              var st = getDiscountCodeEntryState(data, newCode);
              var codeRejected =
                (hasFlags && (!st.found || st.applicable === false)) ||
                (!hasFlags && st.applicable === false);
              if (codeRejected) {
                var revert = existing.join(',');
                return fetch('/cart/update.js', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json'
                  },
                  body: JSON.stringify({ discount: revert })
                }).then(function() {
                  var msg = extractCartDiscountApiMessage(data) || CART_DISCOUNT_GENERIC_ERR;
                  throw new Error(msg);
                });
              }
              return data;
            });
          });
        })
        .then(function() {
          if (cartSection) cartSection.classList.add('is-cart-section-refreshing');
          return refreshCartSection();
        })
        .then(function() {
          updateCartCount();
          setCartPromoFeedback(
            'Discount applied — your items, discount lines, and total above are updated.',
            false
          );
          announceCartMessage('status', 'Discount applied. Your cart has been updated.');
          var freshInput = document.querySelector('[data-cart-discount-input]');
          if (freshInput) freshInput.value = '';
          setCartDiscountInputInvalid(false);
        })
        .catch(function(err) {
          var raw = (err && err.message) || CART_DISCOUNT_GENERIC_ERR;
          var msg = userFacingDiscountError(raw);
          setCartPromoFeedback(msg, true);
          announceCartMessage('error', msg);
          var already = raw.indexOf('already applied') !== -1;
          setCartDiscountInputInvalid(!already);
          var inpErr = document.querySelector('[data-cart-discount-input]');
          if (inpErr) inpErr.focus();
        })
        .finally(function() {
          var freshSection = document.querySelector('[data-cart-section]');
          if (freshSection) freshSection.classList.remove('is-cart-section-refreshing');
          var btn = document.querySelector('[data-cart-apply-discount]');
          if (btn) {
            btn.disabled = false;
            btn.removeAttribute('aria-busy');
          }
        });
    }
    if (discountApplyBtn && discountInput) {
      discountApplyBtn.addEventListener('click', function(e) {
        e.preventDefault();
        applyCartDiscountCode();
      });
      discountInput.addEventListener('keydown', function(e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          applyCartDiscountCode();
        }
      });
      discountInput.addEventListener('input', function() {
        setCartDiscountInputInvalid(false);
        if ((this.value || '').length > 0) {
          setCartPromoFeedback('', false);
        }
      });
    }
  }

  initCartPageAjax();

  // Section entrance animation with Theme Editor-safe refresh
  (function() {
    var revealEnabled = window.mogiRevealEnabled !== false;
    if (!revealEnabled) return;

    var revealSelector = [
      'main > section',
      'main > div[class]',
      'main > article',
      'main > aside'
    ].join(', ');
    var revealClass = 'mogi-reveal';
    var visibleClass = 'is-visible';
    var designMode = typeof Shopify !== 'undefined' && !!Shopify.designMode;
    var observer = null;

    function markRevealTargets(scope) {
      var root = scope && scope.querySelectorAll ? scope : document;
      var targets = [];

      // Include root if it is itself a valid reveal candidate.
      if (scope && scope.matches && scope.matches(revealSelector)) {
        targets.push(scope);
      }

      Array.prototype.forEach.call(root.querySelectorAll(revealSelector), function(el) {
        targets.push(el);
      });

      targets.forEach(function(el, index) {
        if (el.classList.contains(revealClass)) return;
        el.classList.add(revealClass);
        el.style.setProperty('--mogi-reveal-order', String(index));
      });
    }

    function revealNow(scope) {
      var root = scope && scope.querySelectorAll ? scope : document;
      if (scope && scope.classList && scope.classList.contains(revealClass)) {
        scope.classList.add(visibleClass);
      }
      Array.prototype.forEach.call(root.querySelectorAll('.' + revealClass), function(el) {
        el.classList.add(visibleClass);
      });
    }

    function bindObserver(scope) {
      if (!observer) return;
      var root = scope && scope.querySelectorAll ? scope : document;
      var nodes = [];

      if (scope && scope.classList && scope.classList.contains(revealClass)) {
        nodes.push(scope);
      }
      Array.prototype.forEach.call(root.querySelectorAll('.' + revealClass), function(el) {
        nodes.push(el);
      });

      nodes.forEach(function(el) {
        if (!el.classList.contains(visibleClass)) {
          observer.observe(el);
        }
      });
    }

    function initialize(scope) {
      markRevealTargets(scope);
      if (designMode) {
        revealNow(scope);
      } else {
        bindObserver(scope);
      }
    }

    if (!designMode && 'IntersectionObserver' in window) {
      observer = new IntersectionObserver(function(entries, obs) {
        entries.forEach(function(entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add(visibleClass);
          obs.unobserve(entry.target);
        });
      }, {
        root: null,
        rootMargin: '0px 0px -8% 0px',
        threshold: 0.12
      });
    }

    initialize(document);

    if (!observer && !designMode) {
      revealNow(document);
    }

    if (typeof document !== 'undefined') {
      document.addEventListener('shopify:section:load', function(event) {
        initialize(event && event.target ? event.target : document);
      });
      document.addEventListener('shopify:section:reorder', function() {
        initialize(document);
      });
    }
  })();

  // Track search terms and render related search chips on product pages
  (function() {
    var SEARCH_STORAGE_KEY = 'mogi_recent_search_terms';
    var STORAGE_MAX = 25;

    function parseCsv(input) {
      if (!input) return [];
      return String(input)
        .split(',')
        .map(function(item) { return item.trim(); })
        .filter(function(item) { return !!item; });
    }

    function normalizeTerm(value) {
      return String(value || '')
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase();
    }

    function readStoredTerms() {
      try {
        var raw = JSON.parse(localStorage.getItem(SEARCH_STORAGE_KEY) || '[]');
        if (!Array.isArray(raw)) return [];
        return raw.filter(function(item) { return typeof item === 'string' && item.trim(); });
      } catch (e) {
        return [];
      }
    }

    function writeStoredTerms(terms) {
      try {
        localStorage.setItem(SEARCH_STORAGE_KEY, JSON.stringify(terms.slice(0, STORAGE_MAX)));
      } catch (e) {}
    }

    function rememberCurrentSearchTerm() {
      var path = (window.location && window.location.pathname) || '';
      if (path.indexOf('/search') !== 0) return;
      var params = new URLSearchParams(window.location.search || '');
      var term = (params.get('q') || '').trim();
      if (!term) return;
      var normalized = normalizeTerm(term);
      if (!normalized) return;

      var existing = readStoredTerms();
      var merged = [term].concat(existing.filter(function(item) {
        return normalizeTerm(item) !== normalized;
      }));
      writeStoredTerms(merged);
    }

    function buildUniqueTerms(recent, custom, fallback, maxCount) {
      var out = [];
      var seen = {};
      var all = recent.concat(custom).concat(fallback);
      all.forEach(function(term) {
        if (out.length >= maxCount) return;
        var normalized = normalizeTerm(term);
        if (!normalized || seen[normalized]) return;
        seen[normalized] = true;
        out.push(String(term).trim());
      });
      return out;
    }

    function renderRelatedSearches(scope) {
      var root = scope && scope.querySelectorAll ? scope : document;
      var blocks = root.querySelectorAll('[data-related-searches]');
      if (!blocks.length) return;

      var recentPool = readStoredTerms();

      blocks.forEach(function(block) {
        var list = block.querySelector('[data-related-searches-list]');
        if (!list) return;

        var maxCount = parseInt(block.getAttribute('data-limit'), 10);
        if (!maxCount || maxCount < 1) maxCount = 10;

        var recentLimit = parseInt(block.getAttribute('data-recent-limit'), 10);
        if (!recentLimit || recentLimit < 1) recentLimit = 8;

        var includeRecent = block.getAttribute('data-include-recent') === 'true';
        var customTerms = parseCsv(block.getAttribute('data-custom-terms'));
        var fallbackTerms = parseCsv(block.getAttribute('data-fallback-terms'));
        var recentTerms = includeRecent ? recentPool.slice(0, recentLimit) : [];
        var finalTerms = buildUniqueTerms(recentTerms, customTerms, fallbackTerms, maxCount);

        if (!finalTerms.length) {
          list.innerHTML = '';
          return;
        }

        list.innerHTML = finalTerms.map(function(term) {
          var href = '/search?q=' + encodeURIComponent(term);
          return '<a class="product-main__related-search-chip" href="' + href + '">' + escapeHtml(term) + '</a>';
        }).join('');
      });
    }

    rememberCurrentSearchTerm();
    renderRelatedSearches(document);

    if (typeof document !== 'undefined') {
      document.addEventListener('shopify:section:load', function(event) {
        renderRelatedSearches(event && event.target ? event.target : document);
      });
    }
  })();
})();

